/*
Purpose: View details of student
Developer: BY KTH
Date:22/08/2023
Project: TCMS
*/
/*
Purpose: View details of student
Designed: BY R.Sanjai
Date:22/08/2023
Project: TCMS
*/

import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import DiagnosticsMappingCard from './DiagnosticsMappingCard';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Stack from 'react-bootstrap/Stack';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import Nav from 'react-bootstrap/Nav';
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Modal from 'react-bootstrap/Modal';
import CallIcon from '@mui/icons-material/Call';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import Badge from 'react-bootstrap/Badge';

import React from 'react';
import 'react-data-table-component-extensions/dist/index.css';
import { columns, data } from './data.js';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Moment from 'moment';
import Select from 'react-select';
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { FiEye, FiEyeOff } from "react-icons/fi"; // Assuming you've imported the eye icons

import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";

import axios from "axios";
import {
    security_key, BASE_URL
} from "../global";

import { downloadStudentProfilePdf } from "./studentProfilePdf";

import 'react-phone-input-2/lib/style.css'; // Import CSS styles for the phone input
import PhoneInput from 'react-phone-input-2';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {getPhoneCountry} from "./PhoneCountrySession";
import { phoneSchema, phoneInputProps, phoneOnChange, isoFromPhone } from "../utils/phoneValidation";


function getPhoneCountryCode() {

    return getPhoneCountry();
}


function ViewStudent() {

    const navigate = useNavigate();


    const [modalShow, setModalShow] = useState(false);
    const [modalPaymentNotesShow, setModalPaymentNotesShow] = useState(false);

    const [showModalReduceCoins, setShowModalReduceCoins] = useState(false);
    const toggleModalReduceCoins = () => setShowModalReduceCoins(!showModalReduceCoins);
    const [isReduceCoinsSubmitting, setIsReduceCoinsSubmitting] = useState(false);

    const [showModalAddCoins, setShowModalAddCoins] = useState(false);
    const toggleModalAddCoins = () => setShowModalAddCoins(!showModalAddCoins);
    const [isAddCoinsSubmitting, setIsAddCoinsSubmitting] = useState(false);

    const [showModalAddPoints, setShowModalAddPoints] = useState(false);
    const toggleModalAddPoints = () => setShowModalAddPoints(!showModalAddPoints);
    const [isAddPointsSubmitting, setIsAddPointsSubmitting] = useState(false);

    const [showModalReducePoints, setShowModalReducePoints] = useState(false);
    const toggleModalReducePoints = () => setShowModalReducePoints(!showModalReducePoints);
    const [isReducePointsSubmitting, setIsReducePointsSubmitting] = useState(false);

//external parent start
    const [showModal1, setShowModal1] = useState(false);
    const toggleModal1 = () => setShowModal1(!showModal1);

    const [Options_parent, setOptions_par] = useState([]);
    const [IsSubmittingParent, setIsSubmittingParent] = useState(false);


    const [showPrimary, setPrimaryShow] = useState(false);
    const [data_Primary, setPrimaryLabelData] = useState({});
    const [isPrimarySubmitting, setIsPrimarySubmitting] = useState(false);


    const handlePrimaryClick = (row) => {

        setPrimaryLabelData(row);

        setPrimaryShow(true);
    };

    const [showDelete, setDeleteShow] = useState(false);
    const [data_delete, setDeleteLabelData] = useState({});
    const [isUserDeleteSubmitting, setIsUserDeleteSubmitting] = useState(false);


    const handleDeleteClick = (row) => {

      setDeleteLabelData(row);

      setDeleteShow(true);
    };


    const [externalLoading, setExternalLoading] = useState(true);


    const [Id, setId] = useState(null);
    const [note_data, setNotes] = useState([]);
    const [tutor_note_data, setTutorNotes] = useState([]);
    const [payment_note_data, setPaymentNotes] = useState([]);
    const [wallet_data, setWalletData] = useState([]);
    const [OfflineModesOptions, setOfflineModesOptions] = useState([]);

    const [lesson_data, setLessonData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [coin_data, setCoinData] = useState([]);
    const [point_data, setPointData] = useState([]);
    const [test_data, setTestData] = useState([]);
    const [fieldDetails, setFieldDetails] = useState([]);

    // School test scores (centre-entered) shown on the Test Details tab
    const [schoolTestData, setSchoolTestData] = useState([]);
    // Year-level options for the test-score dropdown. Fetched in-component (like EditStudent)
    // rather than from global.js, whose import-time fetch is often empty on first render.
    const [yearLevelOptions, setYearLevelOptions] = useState([]);
    const [modalSchoolTestShow, setModalSchoolTestShow] = useState(false);
    const [isSchoolTestSubmitting, setIsSchoolTestSubmitting] = useState(false);
    const [editingSchoolTestKey, setEditingSchoolTestKey] = useState(null);
    // Only centre admins (user_type 0) can add / edit / delete for now; staff see read-only
    const isCentreAdmin = sessionStorage.getItem('user_type') == 0;

    // Student goals (centre-entered, richer feature). Any centre user (admin + staff) can manage.
    const [goalData, setGoalData] = useState([]);
    const [modalGoalShow, setModalGoalShow] = useState(false);
    const [isGoalSubmitting, setIsGoalSubmitting] = useState(false);
    const [editingGoalKey, setEditingGoalKey] = useState(null);
    const goalStatusOptions = [
        { value: "Not started", label: "Not started" },
        { value: "In progress", label: "In progress" },
        { value: "Achieved", label: "Achieved" },
        { value: "On hold", label: "On hold" },
    ];


    /* ---------------------------------------------------------------------- */
    /* STATE Student pause                                                              */
    /* ---------------------------------------------------------------------- */

    const [pause_data, setPauseData] = useState([]);
    const [modalPauseShow, setModalPauseShow] = useState(false);   // edit form modal
    const [showPauseEditConfirm, setShowPauseEditConfirm] = useState(false); // confirm-before-submit modal
    const [isPauseSubmitting, setIsPauseSubmitting] = useState(false);
    const [editingPauseKey, setEditingPauseKey] = useState(null);
    const [editingPauseRow, setEditingPauseRow] = useState(null); // full row, for the session label in the radio option


    /* ---------------------------------------------------------------------- */
    /* 4. HELPERS — core dayjs comparisons, no plugins                         */
    /* ---------------------------------------------------------------------- */

    const isSameOrAfterDay = (a, b) => a.isSame(b, "day") || a.isAfter(b, "day");
    const isSameOrBeforeDay = (a, b) => a.isSame(b, "day") || a.isBefore(b, "day");

    const [showDeletePause, setDeletePauseShow] = useState(false);
    const [data_deletePause, setDeletePauseData] = useState({});
    const [isPauseDeleteSubmitting, setIsPauseDeleteSubmitting] = useState(false);

    const handleDeletePauseClick = (row) => {
        setDeletePauseData(row);
        setDeletePauseShow(true);
    };


    //Get key value start
    const location = useLocation();
    useEffect(() => {

        const { pk_student_key } = location.state || {};

        const extractedSId = pk_student_key;
        console.log(extractedSId)

        if (extractedSId !== '' && extractedSId !== undefined) {
            setId(extractedSId);
            fetchData(extractedSId);
            fetchMasterData(extractedSId);
            fetchWalletData(extractedSId);
            fetchPauseData(extractedSId);
            fetchCoinData(extractedSId);
            fetchPointData(extractedSId);
            fetchFieldData(extractedSId);
        }else{
            navigate("/list-students");
        }
    }, [location]);
    //Get key value end

    // Fetch year-level options for the test-score dropdown (country-specific)
    useEffect(() => {
        axios.post(BASE_URL + 'API/api_index.php', {
            security_key: security_key,
            country_id: sessionStorage.getItem('country_code'),
            mode: "getCountryYearLevel"
        })
            .then(response_year => {
                if (response_year.data.success === true && Array.isArray(response_year.data.data)) {
                    const formattedyearOptions = response_year.data.data.map(option => ({
                        value: option.activity_level_id,
                        label: option.level_name
                    }));
                    setYearLevelOptions(formattedyearOptions);
                }
            })
            .catch(error => {
                console.error('Error fetching year level options: ', error);
            });
    }, []);


    const [StudentData, setStudentData] = useState({});
    const [StudentSecParData, setSecondaryParentData] = useState({});
    const [StudentAge, setAge] = useState(0);

    const [PendingAmount, setPendingAmount] = useState(0.00);

    const [TotalAmountPaid, setTotalAmountPaid] = useState(0.00);

    const [passwordVisible, setPasswordVisible] = useState(false);


    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const [ConpasswordVisible, setConPasswordVisible] = useState(false);


    const toggleConPasswordVisibility = () => {
        setConPasswordVisible(!ConpasswordVisible);
    };



    const [passwordVisible2, setPasswordVisible2] = useState(false);


    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };


    //Api call start

    const fetchMasterData = (Id) => {
        // Make an API request to fetch the options

            axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                fk_student_key: Id,
                fk_cent_key: sessionStorage.getItem('key'),
                mode: "getAllStudentParentbyCenter"
            })
            .then(response_par => {
                // Assuming the API response is an array of objects with 'id' and 'value' properties
                const formattedOptions_par = response_par.data.data.map(option => ({
                    value: option.pk_par_key,
                    label: option.par_firstname + ' ' + option.par_surname
                }));
                formattedOptions_par.unshift({
                    value: '0',
                    label: 'Select Existing Parent'
                });
                setOptions_par(formattedOptions_par);
            })
            .catch(error => {
                console.error('Error fetching options from API: ', error);
            });

            axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                fk_student_key: Id,
                fk_cent_key: sessionStorage.getItem('key'),
                mode: "getPendingAmountStudent"
            })
            .then(response_pending => {
                // Assuming the API response is an array of objects with 'id' and 'value' properties


                if(response_pending.data.success === true){

                    if(response_pending.data.data.length > 0){
                        let pending_amount = response_pending.data.data[0].nextPaymentAmount;
                        let final_amount = parseFloat(pending_amount).toFixed(2);

                        let paid_amount = response_pending.data.data[0].nextPaymentAmount;
                        let total_paid_amount = parseFloat(paid_amount).toFixed(2);
                        setTotalAmountPaid(total_paid_amount);
                        setPendingAmount(final_amount);


                    }else{
                        setTotalAmountPaid(0.00);
                        setPendingAmount(0.00);
                    }

                }else{
                    setTotalAmountPaid(0.00);
                    setPendingAmount(0.00);
                }
            })
            .catch(error => {
                setTotalAmountPaid(0.00);
                setPendingAmount(0.00);
                console.error('Error fetching options from API: ', error);
            });
            // get Offline payment Modes
            axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getOfflinePaymentModeCenter", //"getAllSubjectByStudent"
                fk_cent_key: sessionStorage.getItem('key')
            })
            .then(response => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            const formattedOptions = response.data.data.map(option => ({
                value: option.pk_cpm_key,
                label: option.pm_name
            }));

            setOfflineModesOptions(formattedOptions);
            })
            .catch(error => {
            //console.error('Error fetching options from API: ', error);
            });
    };

    const fetchCoinData = async (id) => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getTotalCoins",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setCoinData(response.data.data);
                    setCoinRecords(response.data.data);
                } else {
                    setCoinData([]);
                    setCoinRecords([]);
                }
            } else {
                setCoinData([]);
                setCoinRecords([]);
            }
        } catch (error) {
            console.error('Error fetching coin data:', error);
        }
    };

    const fetchPointData = async (id) => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getTotalPoints",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setPointData(response.data.data);
                    setPointRecords(response.data.data);
                } else {
                    setPointData([]);
                    setPointRecords([]);
                }
            } else {
                setPointData([]);
                setPointRecords([]);
            }
        } catch (error) {
            console.error('Error fetching point data:', error);
            setPointData([]);
            setPointRecords([]);
        }
    };

    // Dynamic "Other Details" enrolment fields (shown on the /student-profile page)
    const fetchFieldData = async (id) => {
        try {
            const response = await axios.post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                mode: "getCenterSingleStudentEnrolFields",
                fk_cent_key: sessionStorage.getItem('key'),
                pk_student_key: id
            });

            if (response.data.success === true && response.data.data.length > 0) {
                setFieldDetails(response.data.data);
            } else {
                setFieldDetails([]);
            }
        } catch (error) {
            console.error("Error fetching field data:", error);
            setFieldDetails([]);
        }
    };

    const fetchData = async (id) => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getSingleStudent",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setStudentData(response.data.data[0]);

                    if (response.data.data[0]['st_dob'] != null && response.data.data[0]['st_dob'] != '') {

                        var today = new Date();
                        var birthDate = new Date(response.data.data[0]['st_dob']);  // create a date object directly from `dob1` argument
                        var age_now = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age_now--;
                        }

                        setAge(age_now);
                    }

                }


            } else {
                // Handle unsuccessful response, e.g., show an alert to the user.
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getSingleStudentSecondaryParent",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setSecondaryParentData(response.data.data[0]);
                    setExternalLoading(false);


                }else{
                    setSecondaryParentData([]);
                    setExternalLoading(false);
                }


            } else {
                setSecondaryParentData([]);
                setExternalLoading(false);
                // Handle unsuccessful response, e.g., show an alert to the user.
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getAllStudentNotes",
                fk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setNotes(response.data.data);

                }


            } else {
                // Handle unsuccessful response, e.g., show an alert to the user.
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        try {
            const responseTutorNotes = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getTutorStudentNotes",
                fk_student_key: id
            });

            if (responseTutorNotes.data.success === true) {
                setTutorNotes(responseTutorNotes.data.data || []);
            } else {
                setTutorNotes([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setTutorNotes([]);
        }

        try {
            const responsePayment = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getAllStudentPaymentNotes",
                fk_student_key: id
            });

            if (responsePayment.data.success === true) {
                if (responsePayment.data.data.length > 0) {
                    setPaymentNotes(responsePayment.data.data);

                }else{
                    setPaymentNotes([]);
                }


            } else {
                setPaymentNotes([]);
                // Handle unsuccessful response, e.g., show an alert to the user.
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getLesson",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setLessonData(response.data.data);
                    //setLessionRecords(response.data.data);

                    const today = new Date().toISOString().split('T')[0];
                    const nextMonth = new Date();
                    nextMonth.setMonth(nextMonth.getMonth() + 1);
                    const endDateValue = nextMonth.toISOString().split('T')[0];

                    setStartDate(today);
                    setEndDate(endDateValue);
                    const filterStartDate = today ? new Date(today).getTime() : null;
                    const filterEndDate = endDateValue ? new Date(endDateValue).getTime() : null;

                    const filteredData = response.data.data.filter((record) => {
                        const lessonStartDate = new Date(record.ses_date).getTime();
                        const lessonEndDate = new Date(record.ses_date).getTime();

                        return (
                            (filterStartDate === null || lessonStartDate >= filterStartDate) &&
                            (filterEndDate === null || lessonEndDate <= filterEndDate)
                        );
                    });

                    setLessionRecords(filteredData);
                    setFilteredLessonRecords(filteredData);

                    setLoading(false);


                } else {
                    setLoading(false);
                }


            } else {
                // Handle unsuccessful response, e.g., show an alert to the user.
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }



        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getSingleStudentTestDetails",
                pk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setTestData(response.data.data);
                    setTestRecords(response.data.data);
                    setLoading(false);


                } else {
                    setLoading(false);
                }


            } else {
                // Handle unsuccessful response, e.g., show an alert to the user.
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }


        // School test scores (centre-entered) for the Test Details tab
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getStudentSchoolTests",
                fk_student_key: id
            });

            if (response.data.success === true && Array.isArray(response.data.data)) {
                setSchoolTestData(response.data.data);
            } else {
                setSchoolTestData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setSchoolTestData([]);
        }


        // Student goals (centre-entered) for the Goals tab
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getStudentGoals",
                fk_student_key: id
            });

            if (response.data.success === true && Array.isArray(response.data.data)) {
                setGoalData(response.data.data);
            } else {
                setGoalData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setGoalData([]);
        }



    };

    /* ---------------------------------------------------------------------- */
    /* FETCH — add fetchPauseData(id) call inside the same useEffect that   */
    /*    already calls fetchWalletData(extractedSId), and define it near      */
    /*    fetchWalletData.                                                     */
    /* ---------------------------------------------------------------------- */

    const fetchPauseData = async (id) => {
        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getStudentPauses",
                fk_student_key: id
            });

            if (response.data.success === true && Array.isArray(response.data.data)) {
                setPauseData(response.data.data);
            } else {
                setPauseData([]);
            }
        } catch (error) {
            console.error('Error fetching pause data:', error);
            setPauseData([]);
        }
    };
    //Api call End
    const [lessonRecords, setLessionRecords] = useState(lesson_data);
    const [filteredLessonRecords, setFilteredLessonRecords] = useState([]);
    const [TestRecords, setTestRecords] = useState(test_data);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    //Lesson Start
    const columnsLesson = [

        {
            headerName: 'Title',
            field: "Title",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.title == null || params.row.title == '' ? '-' : params.row.title}`;
            },
        },
        {
            headerName: 'Description',
            field: "Description",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.description == null || params.row.description == '' ? '-' : params.row.description}`;
            },
        },
        {
            headerName: 'Session Name',
            field: "Session Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sest_name == null || params.row.sest_name == '' ? '-' : params.row.sest_name}`;
            },
        },
        {
            headerName: 'Tutor Name',
            field: "Tutor Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.tut_fname == null || params.row.tut_fname == '' ? '-' : params.row.tut_fname + ' ' + params.row.tut_surname}`;
            },

        },
        {

            headerName: 'Date',
            field: "Date",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.ses_date == null || params.row.ses_date == '' ? '-' : Moment(params.row.ses_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },
        },
        {
            headerName: 'Start Time',
            field: "Start Time",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.ses_start_time == null || params.row.ses_start_time == '' ? '-' : Moment(params.row.ses_start_time, "HH:mm:ss").format('HH:mm')}`;
            },

        },
        {
            headerName: 'End Time',
            field: "End Time",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.ses_end_time == null || params.row.ses_end_time == '' ? '-' : Moment(params.row.ses_end_time, "HH:mm:ss").format('HH:mm')}`;
            },

        },
        {

            headerName: 'Activity Count',
            field: "Activity Count",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.count_lesson_activity == null || params.row.count_lesson_activity == '' ? '0' : params.row.count_lesson_activity}`;
            },

        },
    ];




    const handleStartDateChange = (event) => {

        const newStartDate = dayjs(event, 'YYYY-MM-DD').format('YYYY-MM-DD');

        setStartDate(newStartDate);
        handleDateFilter(newStartDate, endDate);
    };

    const handleEndDateChange = (event) => {
        const newEndDate = dayjs(event, 'YYYY-MM-DD').format('YYYY-MM-DD');
        //const newEndDate = event.target.value;
        setEndDate(newEndDate);
        handleDateFilter(startDate, newEndDate);
    };

    const handleDateFilter = (start, end) => {
        const filterStartDate = start ? new Date(start).getTime() : null;
        const filterEndDate = end ? new Date(end).getTime() : null;

        const filteredData = lesson_data.filter((record) => {
            const lessonStartDate = new Date(record.ses_date).getTime();
            const lessonEndDate = new Date(record.ses_date).getTime();

            return (
                (filterStartDate === null || lessonStartDate >= filterStartDate) &&
                (filterEndDate === null || lessonEndDate <= filterEndDate)
            );
        });

        setLessionRecords(filteredData);
        setFilteredLessonRecords(filteredData);
    };

    const handleDateReset = () => {
        const today = new Date().toISOString().split('T')[0];
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        const endDateValue = nextMonth.toISOString().split('T')[0];

        setStartDate(today);
        setEndDate(endDateValue);
        handleDateFilter(today, endDateValue);
        //setLessionRecords(lesson_data);
    };

    //Lesson End



    //Coin Start

    const [CoinRecords, setCoinRecords] = useState(coin_data);
    const [PointRecords, setPointRecords] = useState(point_data);

    const currentStudentSpendableCoins =
        CoinRecords && CoinRecords.length > 0
            ? Math.max(0, Number(CoinRecords[0]?.spendable_coins || 0))
            : 0;

    const currentStudentCoins =
        CoinRecords && CoinRecords.length > 0
            ? Number(CoinRecords[0]?.coins || 0)
            : 0;

    const currentStudentAvailablePoints =
        PointRecords && PointRecords.length > 0
            ? Math.max(0, Number(PointRecords[0]?.available_points || 0))
            : 0;

    const currentStudentPoints =
        PointRecords && PointRecords.length > 0
            ? Number(PointRecords[0]?.points || 0)
            : 0;
    //Lesson Start
    const columnsCoin = [

        {
            headerName: 'Name',
            field: "Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.st_first_name || ''} ${params.row.st_surname || ''}`;
            },

        },
        {
            headerName: 'Lifetime Coins',
            field: "Total Coins",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.coins == null || params.row.coins == '' ? '0' : params.row.coins}`;
            },
        }
    ];

    const columnsPoint = [
        {
            headerName: 'Name',
            field: "Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.st_first_name || ''} ${params.row.st_surname || ''}`;
            },
        },
        {
            headerName: 'Lifetime Points',
            field: "Total Points",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.points == null || params.row.points == '' ? '0' : params.row.points}`;
            },
        }
    ];
    //Coin End

    const basicSchemaReduceCoins = yup.object().shape({
        coin_amount: yup
            .number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .typeError("Amount must be a number")
            .integer("Amount must be a whole number")
            .positive("Amount must be greater than 0.")
            .max(currentStudentSpendableCoins, "Insufficient coins for this deduction.")
            .required("Amount is required."),

        remarks: yup
            .string()
            .required("Reason is required.")
            .matches(
                /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
                "Avoid start & end with a space or comma"
            ),
    });

    const initialValuesReduceCoins = {
        coin_amount: "",
        remarks: "",
        fk_student_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikReduceCoins = useFormik({
        initialValues: initialValuesReduceCoins,
        validationSchema: basicSchemaReduceCoins,
        enableReinitialize: true,
        onSubmit: async (formValues, { resetForm }) => {
            setIsReduceCoinsSubmitting(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "reduceStudentCoinsTCMS",
                    ...formValues,
                });

                if (response.data.success === true && Number(response.data.data) === 1) {
                    toast.success("Coins removed successfully.", {
                        autoClose: 700,
                    });

                    setShowModalReduceCoins(false);
                    resetForm();

                    // refresh from backend so total coins + spendable coins both stay correct
                    await fetchCoinData(Id);
                } else if (String(response?.data?.data) === "2") {
                    toast.error("Insufficient spendable coins for this deduction.", {
                        autoClose: 700,
                    });
                } else {
                    toast.error(
                        response?.data?.message || "Failed to remove coins. Try again later.",
                        {
                            autoClose: 700,
                        }
                    );
                }
            } catch (error) {
                console.error("Error removing coins:", error);
                toast.error("Failed to remove coins. Try again later.", {
                    autoClose: 700,
                });
            } finally {
                setIsReduceCoinsSubmitting(false);
            }
        },
    });

    const basicSchemaAddCoins = yup.object().shape({
        coin_amount: yup
            .number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .typeError("Amount must be a number")
            .integer("Amount must be a whole number")
            .positive("Amount must be greater than 0.")
            .required("Amount is required."),
        remarks: yup
            .string()
            .required("Reason is required.")
            .matches(
                /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
                "Avoid start & end with a space or comma"
            ),
    });

    const formikAddCoins = useFormik({
        initialValues: initialValuesReduceCoins,
        validationSchema: basicSchemaAddCoins,
        enableReinitialize: true,
        onSubmit: async (formValues, { resetForm }) => {
            setIsAddCoinsSubmitting(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "addStudentCoinsTCMS",
                    ...formValues,
                });

                if (response.data.success === true && Number(response.data.data) === 1) {
                    toast.success("Coins added successfully.", {
                        autoClose: 3000,
                    });

                    setShowModalAddCoins(false);
                    resetForm();
                    await fetchCoinData(Id);
                } else {
                    toast.error(
                        response?.data?.message || "Failed to add coins. Try again later.",
                        { autoClose: 3000 }
                    );
                }
            } catch (error) {
                console.error("Error adding coins:", error);
                toast.error("Failed to add coins. Try again later.", {
                    autoClose: 3000,
                });
            } finally {
                setIsAddCoinsSubmitting(false);
            }
        },
    });

    const basicSchemaAddPoints = yup.object().shape({
        point_amount: yup
            .number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .typeError("Amount must be a number")
            .integer("Amount must be a whole number")
            .positive("Amount must be greater than 0.")
            .required("Amount is required."),
        remarks: yup
            .string()
            .required("Reason is required.")
            .matches(
                /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
                "Avoid start & end with a space or comma"
            ),
    });

    const basicSchemaReducePoints = yup.object().shape({
        point_amount: yup
            .number()
            .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
            )
            .typeError("Amount must be a number")
            .integer("Amount must be a whole number")
            .positive("Amount must be greater than 0.")
            .max(currentStudentAvailablePoints, "Insufficient points for this deduction.")
            .required("Amount is required."),
        remarks: yup
            .string()
            .required("Reason is required.")
            .matches(
                /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
                "Avoid start & end with a space or comma"
            ),
    });

    const initialValuesPoints = {
        point_amount: "",
        remarks: "",
        fk_student_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikAddPoints = useFormik({
        initialValues: initialValuesPoints,
        validationSchema: basicSchemaAddPoints,
        enableReinitialize: true,
        onSubmit: async (formValues, { resetForm }) => {
            setIsAddPointsSubmitting(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "addStudentPointsTCMS",
                    ...formValues,
                });

                if (response.data.success === true && Number(response.data.data) === 1) {
                    toast.success("Points added successfully.", {
                        autoClose: 3000,
                    });

                    setShowModalAddPoints(false);
                    resetForm();
                    await fetchPointData(Id);
                } else {
                    toast.error(
                        response?.data?.message || "Failed to add points. Try again later.",
                        { autoClose: 3000 }
                    );
                }
            } catch (error) {
                console.error("Error adding points:", error);
                toast.error("Failed to add points. Try again later.", {
                    autoClose: 3000,
                });
            } finally {
                setIsAddPointsSubmitting(false);
            }
        },
    });

    const formikReducePoints = useFormik({
        initialValues: initialValuesPoints,
        validationSchema: basicSchemaReducePoints,
        enableReinitialize: true,
        onSubmit: async (formValues, { resetForm }) => {
            setIsReducePointsSubmitting(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "reduceStudentPointsTCMS",
                    ...formValues,
                });

                if (response.data.success === true && Number(response.data.data) === 1) {
                    toast.success("Points removed successfully.", {
                        autoClose: 3000,
                    });

                    setShowModalReducePoints(false);
                    resetForm();
                    await fetchPointData(Id);
                } else {
                    toast.error(
                        response?.data?.message || "Failed to remove points. Try again later.",
                        { autoClose: 3000 }
                    );
                }
            } catch (error) {
                console.error("Error removing points:", error);
                toast.error("Failed to remove points. Try again later.", {
                    autoClose: 3000,
                });
            } finally {
                setIsReducePointsSubmitting(false);
            }
        },
    });

    //Test Start

    const columns_test = [
        {

            headerName: 'Name',
            field: "Name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.dt_test_name == null || params.row.dt_test_name == '' ? '-' : params.row.dt_test_name}`;
            },

        },
        {
            headerName: 'Type',
            field: "Type",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.dtm_name == null || params.row.dtm_name == '' ? '-' : params.row.dtm_name}`;
            },
        },
        {
            headerName: 'Value',
            field: "Value",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.dt_test_mark == null || params.row.dt_test_mark == '' ? '-' : params.row.dt_test_mark}`;
            },


        },
        {
            headerName: 'Date',
            field: "Date",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.dt_date == null || params.row.dt_date == '' ? '-' : Moment(params.row.dt_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },

        },
        {
            headerName: 'Comment',
            field: "Comment",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.dt_comment == null || params.row.dt_comment == '' ? '-' : params.row.dt_comment}`;
            },

        },

    ];
    //Test End

    // Sample columns configuration
    const columns_notes = [
        {

            headerName: 'Date',
            field: "Date",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sn_date == null || params.row.sn_date == '' ? '-' : Moment(params.row.sn_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },

        },
        {
            headerName: 'Note',
            field: "Note",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sn_note == null || params.row.sn_note == '' ? '-' : params.row.sn_note}`;
            },
        },

    ];

    const columns_tutor_notes = [
        {
            headerName: 'Tutor',
            field: "tutor_name",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                const name = `${params.row.tut_fname || ''} ${params.row.tut_surname || ''}`.trim();
                return name === '' ? '-' : name;
            },
        },
        {
            headerName: 'Note',
            field: "tsn_notes",
            headerClassName: "super-app-theme--header",
            flex: 2,
            valueGetter: (params) => {
                return `${params.row.tsn_notes == null || params.row.tsn_notes == '' ? '-' : params.row.tsn_notes}`;
            },
        },
        {
            headerName: 'Last Updated',
            field: "updated_on",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.updated_on == null || params.row.updated_on == '' ? '-' : Moment(params.row.updated_on).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                    return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }
                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');
                return direction === 'asc' ? dateA - dateB : dateB - dateA;
            },
        },
    ];

    const handleClick = () => {
        // You can use the 'id' value here for further processing

        navigate(`/student-profile`, { state: { pk_student_key: `${Id}` } });

    };


    const handleClick_enroll = () => {
        // You can use the 'id' value here for further processing

        navigate(`/student-entrolments`, { state: { pk_student_key: `${Id}` } });

    };


    const handleClick_diagnostics = () => {
        navigate(`/student-diagnostics-report`, { state: { pk_student_key: `${Id}` } });
    };


    const handleLessonViewClick = async (e) => {


        navigate(`/ListLessonActivity`, { state: { pk_lesson_key: `${e.pk_lesson_key}`, pk_student_key: `${Id}` } });


    }



    const [options_subject, setOptions] = useState([]);


    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        // Make an API request to fetch the options
        axios.post(BASE_URL + 'API/api_index.php', {
            security_key: security_key,
            fk_cent_key: sessionStorage.getItem('key'),
            mode: "getAllSubjectby_center"
        })
            .then(response => {
                // Assuming the API response is an array of objects with 'id' and 'value' properties
                const formattedOptions = response.data.data.map(option => ({
                    value: option.subject_id,
                    label: option.subject_name
                }));
                formattedOptions.unshift({
                    value: '',
                    label: '--Select--'
                });
                setOptions(formattedOptions);
            })
            .catch(error => {
                console.error('Error fetching options from API: ', error);
            });

    }, []);




    function onSubmitPrimary() {
        setIsPrimarySubmitting(true);

        const responsePrimary = axios.post(BASE_URL + "API/api_index.php", {

          security_key: security_key,
          updated_by: sessionStorage.getItem('key'),
          mode: "ParentSetPrimary",
          fk_cent_key: sessionStorage.getItem('key'),
          pk_student_key: Id,
          pk_parent_key: data_Primary
        }).then((responsePrimary) => {

          if (responsePrimary.data.data == 1) {

            setPrimaryShow(false)
            // Handle the successful response here
            toast.success("Success! Parent has been set primary account.", {
              autoClose: 700, // 3 seconds in this example
            });

            fetchData(Id);

            setIsPrimarySubmitting(false);

          } else {
            setPrimaryShow(false)
            toast.error("Failure! Unable to parent account primary. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });
            setIsPrimarySubmitting(false);
          }


        })
          .catch((error) => {
            setPrimaryShow(false)
            // Handle any errors that occurred during the request
            toast.error("Failure! Unable to parent account primary. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });
            setIsPrimarySubmitting(false);
          });
      }


    const basicSchema = yup.object().shape({

        sn_date: yup
        .string()
        .test('is-valid-date', 'Please provide a valid date.', function (value) {
          const parsedDate = dayjs(value, 'YYYY-MM-DD');
          return parsedDate.isValid();
        }).required("Date is required."),
        sn_category: yup.mixed().required("Subject is required."),
        sn_note: yup.string().required("Note is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),

    });

    const initialValues = {
        /*tbl_student*/
        sn_date: "",
        sn_category: "",
        sn_note: "",
        sn_is_critical: false,
        fk_stu_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };



    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        // onSubmit,
        onSubmit: async (formValues) => {
            setIsSubmitting(true);


            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "createStudentNote",
                    ...formValues,
                });

                if (response.data.success === true) {
                    // Reset the form

                    if (response.data.data === 1) {
                        toast.success("Success! Your form was submitted", {
                            autoClose: 700, // 3 seconds in this example
                        });
                        fetchData(Id);
                        // setShow(false);
                        setModalShow(false);

                        resetForm();

                        setIsSubmitting(false); // Re-enable the submit button
                    } else {
                        toast.error("Failure! Unable to create notes. Try again later.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmitting(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failure! Unable to create notes. Try again later.", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsSubmitting(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to create notes. Try again later.", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsSubmitting(false); // Re-enable the submit button

            } finally {
                setIsSubmitting(false); // Re-enable the submit button

            }

        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;


    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm(); // Reset Formik-controlled fields

    };







    const validationSchema1 = yup.object().shape({
        par_firstname: yup.string().required("First name is required.").min(2, "Minimum 2 characters is required.").max(30, "Maximum 30 characters is required.").matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Letters and spaces only at between."),
        par_surname: yup.string().required("Last Name is required.").min(1, "Minimum 1 characters is required.").max(30, "Maximum 30 characters is required.").matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Letters and spaces only at between."),
        par_emailid: yup.string().email("Please enter a valid email address").notRequired().matches(/^[^$&+,:;=?@#|'<>.^*()%!-]+/, 'Input cannot start with a special character').test('no-dot', 'Please enter a valid email address', function (value) {
            return !value || value && value.includes('.');
          }),
        par_countryCode: yup.string().notRequired(),
        // par_phone: yup
        // .string()
        // .test(
        //   'minDigits',
        //   'Minimum 5 digits required',
        //   function (value) {
        //     const { par_countryCode } = this.parent;
        //     const countryCodeLength = par_countryCode ? par_countryCode.length : 0;
        //     const phoneLength = value ? value.length : 0;
        //     const difference = phoneLength - countryCodeLength;

        //     // Check if the difference is less than 5
        //     return difference >= 5 || difference === 0;
        //   }
        // )
        // .notRequired(),
        par_phone: phoneSchema('par_countryCode'),
        ps_relationship: yup.string().required("Relationship is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma").matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/,"Avoid apostrophe & quotes."),

        pa_login_id: yup.string().when(['ex_par_key'], {
            is: (ex_par_key) =>
                ex_par_key == '0',
            then: () => yup.string().required("Username is required.").min(2, "Minimum 2 characters is required.").max(30, "Maximum 30 characters is required.").matches(/^[^'"`\s’]+$/, "Avoid spaces, apostrophe & quotes."),
        }),
        pa_password: yup.string().when(['ex_par_key'], {
            is: (ex_par_key) =>
                ex_par_key == '0',
            then: () => yup.string().min(5, "Minimum 5 characters is required.").required("Password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
        }),
        pa_conform_password: yup.string().when(['ex_par_key'], {
            is: (ex_par_key) =>
                ex_par_key == '0',
            then: () => yup
                .string()
                .oneOf([yup.ref("pa_password"), null], "Password is not matching")
                .required("Confirm password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
        }),
    });


    const initialValues1 = {
        /*tbl_parent*/
        par_firstname:'',
        par_surname: '',
        par_emailid: '',
        par_countryCode: isoFromPhone(''),
        par_phone: '',
        ex_par_key: '0',
        par_address: StudentData ? StudentData.par_address : '',
        par_city: StudentData ? StudentData.par_city : '',
        par_state: StudentData ? StudentData.par_state : '',
        //par_country: StudentData ? StudentData.par_country : '',
        par_country: StudentData ? StudentData.par_country != null && StudentData.par_country != '' ? StudentData.par_country : sessionStorage.getItem('country_code') != null && sessionStorage.getItem('country_code') != '' ? sessionStorage.getItem('country_code') : 'SG' : sessionStorage.getItem('country_code') != null && sessionStorage.getItem('country_code') != '' ? sessionStorage.getItem('country_code') : 'SG',
        par_zip: StudentData ? StudentData.par_zip : '',

        /*tbl_parent_auth*/
        pa_login_id: "",
        pa_password: "",
        pa_conform_password: "",
        pk_student_key: Id,
        created_by: sessionStorage.getItem('key'),
        fk_cent_key: sessionStorage.getItem('key')
    };


    const formik1 = useFormik({
        initialValues: initialValues1,
        validationSchema: validationSchema1,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setIsSubmittingParent(true);


            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "createStudentParent",
                    ...values,
                });

                if (response.data.success === true) {
                    // Reset the form
                    //formRef.current.reset();
                    if (response.data.data === 1) {
                        toast.success("Success! Your form was submitted", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        // setShow(false);
                        fetchData(Id);
                        fetchMasterData(Id);
                        resetForm();
                        toggleModal1();



                        setIsSubmittingParent(false); // Re-enable the submit button
                    }else if (response.data.data === 2) {
                        toast.error("Parents / Guardians username is not available", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingParent(false); // Re-enable the submit button
                    } else {
                        toast.error("Failure! Unable to create Parent. Try again later", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingParent(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failure! Unable to create Parent. Try again later", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsSubmittingParent(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to create Parent. Try again later", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsSubmittingParent(false); // Re-enable the submit button

            } finally {
                setIsSubmittingParent(false); // Re-enable the submit button

            }

        },
    });

    /* --------------Edit Additional Parents / Guardians --------------- */

    const [showModalEditPar, setEditParShowModal] = useState(false);
    const toggleModalEditPar = () => setEditParShowModal(!showModalEditPar);
    const [IsSubmittingEditParent, setIsSubmittingEditParent] = useState(false);

    const validationSchema2 = yup.object().shape({
        par_firstname: yup.string().required("First name is required.").min(2, "Minimum 2 characters is required.").max(30, "Maximum 30 characters is required.").matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Letters and spaces only at between."),
        par_surname: yup.string().required("Last Name is required.").min(1, "Minimum 1 characters is required.").max(30, "Maximum 30 characters is required.").matches(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Letters and spaces only at between."),
        par_emailid: yup.string().email("Please enter a valid email address").notRequired().matches(/^[^$&+,:;=?@#|'<>.^*()%!-]+/, 'Input cannot start with a special character').test('no-dot', 'Please enter a valid email address', function (value) {
            return !value || value && value.includes('.');
          }),
        par_countryCode: yup.string().notRequired(),
        par_phone: phoneSchema('par_countryCode'),
        ps_relationship: yup.string().required("Relationship is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma").matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/,"Avoid apostrophe & quotes."),
    });

    const initialValues2 = {
        ps_relationship: StudentSecParData && StudentSecParData.ps_relationship != null ? StudentSecParData.ps_relationship : '',
        par_firstname: StudentSecParData && StudentSecParData.par_firstname != null ? StudentSecParData.par_firstname : '',
        par_surname: StudentSecParData && StudentSecParData.par_surname != null ? StudentSecParData.par_surname : '',
        par_emailid: StudentSecParData && StudentSecParData.par_emailid != null ? StudentSecParData.par_emailid : '',
        par_phone: StudentSecParData && StudentSecParData.par_phone != null ? StudentSecParData.par_phone : '',
        par_countryCode: isoFromPhone(StudentSecParData ? StudentSecParData.par_phone : ''),
        pk_par_key: StudentSecParData && StudentSecParData.pk_par_key != null ? StudentSecParData.pk_par_key : '',
        pk_student_key: Id,
        updated_by: sessionStorage.getItem('key'),
        fk_cent_key: sessionStorage.getItem('key')
    };

    const formik2 = useFormik({
        initialValues: initialValues2,
        validationSchema: validationSchema2,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setIsSubmittingEditParent(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "updateStudentSecondaryParent",
                    ...values,
                });

                if (response.data.success === true && response.data.data === 1) {
                    toast.success("Success! Your form was submitted", {
                        autoClose: 3000, // 3 seconds in this example
                    });

                    fetchData(Id);
                    fetchMasterData(Id);
                    toggleModalEditPar();

                } else {
                    toast.error("Failure! Unable to update Parent. Try again later", {
                        autoClose: 3000, // 3 seconds in this example
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to update Parent. Try again later", {
                    autoClose: 3000, // 3 seconds in this example
                });

            } finally {
                setIsSubmittingEditParent(false); // Re-enable the submit button
            }

        },
    });

    const [isSubmittingPass, setIsSubmittingPass] = useState(false);

    const [showModalPass, setPassShowModal] = useState(false);
    const toggleModalpass = () => setPassShowModal(!showModalPass);


    const validationSchema3 = yup.object().shape({
        pa_login_id: yup.string()
        .required("Username is required.")
        .min(2, "Minimum 2 characters is required.")
        .max(30, "Maximum 30 characters is required.")
        .matches(/^[^'"`\s’]+$/, "Avoid spaces, apostrophe & quotes."),
        pa_password: yup.string().min(5, "Minimum 5 characters is required.").required("Password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
        pa_conform_password: yup
            .string()
            .oneOf([yup.ref("pa_password"), null], "Password is not matching")
            .required("Confirm password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),

    });



    const initialValues3 = {

        pk_par_key: StudentData ? StudentData.pk_par_key : '',

        /*tbl_center_auth*/
        pa_login_id: StudentData ? StudentData.pa_login_id : '',
        pa_password: StudentData ? StudentData.pa_direct_password : '',
        pa_conform_password: '',
        fk_cent_key: sessionStorage.getItem('key'),
        updated_by: sessionStorage.getItem('key'),
    };

    const formik3 = useFormik({
        initialValues: initialValues3,
        validationSchema: validationSchema3,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setIsSubmittingPass(true);


            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "updateParentAuth_new",
                    ...values,
                });

                if (response.data.success === true) {
                    // Reset the form

                    if (response.data.data === 1) {
                        toast.success("Success! Manage Login.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setTimeout(function () {
                            window.location.reload(false);
                            setIsSubmittingPass(false); // Re-enable the submit button
                        }, 3000); // 3000 milliseconds, which is equivalent to 3 seconds





                    } else if (response.data.data === 2) {

                        toast.error("Parents / Guardians username is not available", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingPass(false); // Re-enable the submit button

                    } else {
                        toast.error("Failure! Unable to update manage login. Try again later", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingPass(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failure! Unable to update manage login. Try again later", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsSubmittingPass(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to update manage login. Try again later", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsSubmittingPass(false); // Re-enable the submit button

            } finally {
                setIsSubmittingPass(false); // Re-enable the submit button

            }

        },
    });



    const [isSubmittingPass2, setIsSubmittingPass2] = useState(false);

    const [showModalPass2, setPassShowModal2] = useState(false);
    const toggleModalpass2 = () => setPassShowModal2(!showModalPass2);


    const validationSchema4 = yup.object().shape({
        pa_login_id: yup.string()
        .required("Username is required.")
        .min(2, "Minimum 2 characters is required.")
        .max(30, "Maximum 30 characters is required.")
        .matches(/^[^'"`\s’]+$/, "Avoid spaces, apostrophe & quotes."),
        pa_password: yup.string().min(5, "Minimum 5 characters is required.").required("Password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
        pa_conform_password: yup
            .string()
            .oneOf([yup.ref("pa_password"), null], "Password is not matching")
            .required("Confirm password is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),

    });



    const initialValues4 = {

        pk_par_key: StudentSecParData ? StudentSecParData.pk_par_key : '',

        /*tbl_center_auth*/
        pa_login_id: StudentSecParData ? StudentSecParData.pa_login_id : '',
        pa_password: StudentSecParData ? StudentSecParData.pa_direct_password : '',
        pa_conform_password: '',
        fk_cent_key: sessionStorage.getItem('key'),
        updated_by: sessionStorage.getItem('key'),
    };

    const formik4 = useFormik({
        initialValues: initialValues4,
        validationSchema: validationSchema4,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setIsSubmittingPass2(true);


            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "updateParentAuth_new",
                    ...values,
                });

                if (response.data.success === true) {
                    // Reset the form
                    //formRef.current.reset();
                    if (response.data.data === 1) {
                        toast.success("Success! Manage Login.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setTimeout(function () {
                            window.location.reload(false);
                            setIsSubmittingPass2(false); // Re-enable the submit button
                        }, 3000); // 3000 milliseconds, which is equivalent to 3 seconds





                    } else if (response.data.data === 2) {

                        toast.error("Parents / Guardians username is not available", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingPass2(false); // Re-enable the submit button

                    } else {
                        toast.error("Failure! Unable to update manage login. Try again later", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsSubmittingPass2(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failure! Unable to update manage login. Try again later", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsSubmittingPass2(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to update manage login. Try again later", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsSubmittingPass2(false); // Re-enable the submit button

            } finally {
                setIsSubmittingPass2(false); // Re-enable the submit button

            }

        },
    });



    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (

        <div className="three-dot-icon" >
            <i className="fas fa-ellipsis-v"  ref={ref}
        onClick={e => {
          e.preventDefault();
          onClick(e);
        }}></i>{children}
        </div>

      ));


      const CustomToggle2 = React.forwardRef(({ children, onClick }, ref) => (

        <div className="three-dot-icon" >
            <i className="fas fa-ellipsis-v"  ref={ref}
        onClick={e => {
          e.preventDefault();
          onClick(e);
        }}></i>{children}
        </div>

      ));


      function onSubmitDelete() {
        setIsUserDeleteSubmitting(true);

        const responsedelete = axios.post(BASE_URL + "API/api_index.php", {

          security_key: security_key,
          updated_by: sessionStorage.getItem('key'),
          mode: "ParentRemovestudent",
          fk_cent_key: sessionStorage.getItem('key'),
          pk_student_key: Id,
          pk_parent_key: data_delete
        }).then((responsedelete) => {

          if (responsedelete.data.data == 1) {

            setDeleteShow(false);
            fetchData(Id);
            // Handle the successful response here
            toast.success("Success! Parent has been removed.", {
              autoClose: 700, // 3 seconds in this example
            });



            setIsUserDeleteSubmitting(false);

          } else {
            toast.error("Failure! Unable to Parent has been remove. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });
            setIsUserDeleteSubmitting(false);
          }


        })
          .catch((error) => {
            // Handle any errors that occurred during the request
            toast.error("Failure! Unable to Parent has been remove. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });
            setIsUserDeleteSubmitting(false);
          });
      }


      function onSubmitDeletePaymentNotes(notesKey) {

        const responsedelete = axios.post(BASE_URL + "API/api_index.php", {

          security_key: security_key,
          mode: "deletePaymentNotes",
          fk_cent_key: sessionStorage.getItem('key'),
          pk_pn_key: notesKey
        }).then((responsedelete) => {

          if (responsedelete.data.data == 1) {

            fetchData(Id);
            // Handle the successful response here
            toast.success("Success! Payment notes has been removed.", {
              autoClose: 700, // 3 seconds in this example
            });

          } else {
            toast.error("Failure! Unable to Payment notes has been remove. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });

          }


        })
          .catch((error) => {
            // Handle any errors that occurred during the request
            toast.error("Failure! Unable to Payment notes has been remove. Try again later", {
              autoClose: 700, // 3 seconds in this example
            });

          });
      }

       const handleDeletePaymentClick = (row) => {
            //console.log(row)
              if(row && row.pk_pn_key){
                onSubmitDeletePaymentNotes(row.pk_pn_key)
              }else{

                toast.error("Sorry, Payment Notes key not found", {
                    autoClose: 700, // 3 seconds in this example
                  });
              }
           };

      const columns_payment_notes = [
        {

            headerName: 'Date',
            field: "Date",
            headerClassName: "super-app-theme--header",
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pn_date == null || params.row.pn_date == '' ? '-' : Moment(params.row.pn_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },

        },
        {
            headerName: 'Note',
            field: "Note",
            headerClassName: "super-app-theme--header",
            minWidth: 530,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pn_notes == null || params.row.pn_notes == '' ? '-' : params.row.pn_notes}`;
            },
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Action",
            headerClassName: "super-app-theme--header",
            width: 100,
            headerAlign:"left",
            renderCell: (params) => {
              const row = params.row;

              return (
                <div className='d-flex  pad-12'>

                    <Button variant="outlined-red" onClick={() => handleDeletePaymentClick(row)} className="filled-danger my-2">Delete </Button>

                </div>
              );
            }
          },

    ];
    const [isPaymentNotesSubmitting, setIsPaymentNotesSubmitting] = useState(false);
    const basicSchemaPaymentNotes = yup.object().shape({

        pn_date: yup
        .string()
        .test('is-valid-date', 'Please provide a valid date.', function (value) {
          const parsedDate = dayjs(value, 'YYYY-MM-DD');
          return parsedDate.isValid();
        }).required("Date is required."),
        pn_note: yup.string().required("Note is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma"),
    });

    const initialValuesPaymentNotes = {
        /*tbl_student*/
        pn_date: "",
        pn_note: "",
        fk_stu_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };



    const formikPaymentNotes = useFormik({
        initialValues: initialValuesPaymentNotes,
        validationSchema: basicSchemaPaymentNotes,
        enableReinitialize: true,
        // onSubmit,
        onSubmit: async (formValues) => {
            setIsPaymentNotesSubmitting(true);


            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "createPaymentNotes",
                    ...formValues,
                });

                if (response.data.success === true) {
                    // Reset the form

                    if (response.data.data === 1) {
                        toast.success("Success! Payment Notes added", {
                            autoClose: 700, // 3 seconds in this example
                        });
                        fetchData(Id);
                        // setShow(false);
                        setModalPaymentNotesShow(false);

                        formikPaymentNotes.resetForm();

                        setIsPaymentNotesSubmitting(false); // Re-enable the submit button
                    } else {
                        toast.error("Failure! Unable to add payment notes. Try again later.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsPaymentNotesSubmitting(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failure! Unable to add payment notes. Try again later.", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsPaymentNotesSubmitting(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to add payment notes. Try again later.", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsPaymentNotesSubmitting(false); // Re-enable the submit button

            } finally {
                setIsPaymentNotesSubmitting(false); // Re-enable the submit button

            }

        },
    });

    /* ---------------- School test scores ---------------- */
    const basicSchemaSchoolTest = yup.object().shape({
        sst_test_name: yup.string().trim().required("Test name is required."),
        sst_test_date: yup
            .string()
            .test('is-valid-date', 'Please provide a valid date.', function (value) {
                const parsedDate = dayjs(value, 'YYYY-MM-DD');
                return parsedDate.isValid();
            })
            .required("Test date is required."),
        sst_score: yup.string()
            .required("Score is required.")
            .matches(/^\s*\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?\s*$/, "Enter score as X/Y (e.g. 80/100).")
            .test('denominator-not-zero', 'The value after / must be greater than 0.', (value) => {
                const m = String(value ?? '').match(/^\s*\d+(?:\.\d+)?\s*\/\s*(\d+(?:\.\d+)?)\s*$/);
                if (!m) return true; // format handled by matches()
                return parseFloat(m[1]) > 0;
            }),
        sst_subject: yup.string().nullable(),
        sst_year_level: yup.mixed().nullable(),
        sst_term: yup.string().nullable(),
        sst_comment: yup.string().nullable(),
    });

    // Derive percentage from a "X/Y" score string; returns "" when not computable
    const computeScorePercentage = (scoreStr) => {
        const m = String(scoreStr ?? "").match(/^\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)\s*$/);
        if (!m) return "";
        const num = parseFloat(m[1]);
        const den = parseFloat(m[2]);
        if (!den) return "";
        return (Math.round((num / den) * 10000) / 100).toString();
    };

    const initialValuesSchoolTest = {
        sst_test_name: "",
        sst_subject: "",
        sst_score: "",
        sst_score_percentage: "",
        sst_year_level: "",
        sst_term: "",
        sst_comment: "",
        sst_test_date: "",
        fk_student_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikSchoolTest = useFormik({
        initialValues: initialValuesSchoolTest,
        validationSchema: basicSchemaSchoolTest,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            setIsSchoolTestSubmitting(true);

            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: editingSchoolTestKey ? "updateStudentSchoolTest" : "createStudentSchoolTest",
                    ...formValues,
                    pk_sst_key: editingSchoolTestKey || undefined,
                    fk_cent_key: sessionStorage.getItem('key'),
                    updated_by: sessionStorage.getItem('key'),
                });

                if (response.data.success === true && response.data.data === 1) {
                    toast.success(editingSchoolTestKey ? "Success! Test score updated." : "Success! Test score added.", {
                        autoClose: 700,
                    });
                    fetchData(Id);
                    setModalSchoolTestShow(false);
                    setEditingSchoolTestKey(null);
                    formikSchoolTest.resetForm();
                } else {
                    toast.error("Failure! Unable to save test score. Try again later.", {
                        autoClose: 700,
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to save test score. Try again later.", {
                    autoClose: 700,
                });
            } finally {
                setIsSchoolTestSubmitting(false);
            }
        },
    });

    const handleAddSchoolTest = () => {
        setEditingSchoolTestKey(null);
        formikSchoolTest.resetForm();
        setModalSchoolTestShow(true);
    };

    const handleEditSchoolTest = (row) => {
        setEditingSchoolTestKey(row.pk_sst_key);
        formikSchoolTest.setValues({
            ...initialValuesSchoolTest,
            sst_test_name: row.sst_test_name ?? "",
            sst_subject: row.sst_subject ?? "",
            sst_score: row.sst_score ?? "",
            sst_score_percentage: row.sst_score_percentage ?? "",
            sst_year_level: row.sst_year_level ?? "",
            sst_term: row.sst_term ?? "",
            sst_comment: row.sst_comment ?? "",
            sst_test_date: row.sst_test_date ?? "",
        });
        setModalSchoolTestShow(true);
    };

    const handleDeleteSchoolTest = (row) => {
        if (!row || !row.pk_sst_key) {
            toast.error("Sorry, test score key not found", { autoClose: 700 });
            return;
        }

        axios.post(BASE_URL + "API/api_index.php", {
            security_key: security_key,
            mode: "deleteStudentSchoolTest",
            fk_cent_key: sessionStorage.getItem('key'),
            pk_sst_key: row.pk_sst_key
        }).then((responsedelete) => {
            if (responsedelete.data.data == 1) {
                fetchData(Id);
                toast.success("Success! Test score has been removed.", { autoClose: 700 });
            } else {
                toast.error("Failure! Unable to remove test score. Try again later", { autoClose: 700 });
            }
        }).catch(() => {
            toast.error("Failure! Unable to remove test score. Try again later", { autoClose: 700 });
        });
    };

    const columns_school_test = [
        {
            headerName: 'Name',
            field: "Name",
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_test_name == null || params.row.sst_test_name == '' ? '-' : params.row.sst_test_name}`;
            },
        },
        {
            headerName: 'Subject',
            field: "Subject",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_subject == null || params.row.sst_subject == '' ? '-' : params.row.sst_subject}`;
            },
        },
        {
            headerName: 'Score',
            field: "Score",
            headerClassName: "super-app-theme--header",
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_score == null || params.row.sst_score === '' ? '-' : params.row.sst_score}`;
            },
        },
        {
            headerName: 'Score %',
            field: "ScorePercentage",
            headerClassName: "super-app-theme--header",
            minWidth: 90,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_score_percentage == null || params.row.sst_score_percentage === '' ? '-' : parseFloat(params.row.sst_score_percentage) + '%'}`;
            },
        },
        {
            headerName: 'Year Level',
            field: "YearLevel",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.level_name == null || params.row.level_name == '' ? '-' : params.row.level_name}`;
            },
        },
        {
            headerName: 'Term',
            field: "Term",
            headerClassName: "super-app-theme--header",
            minWidth: 110,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_term == null || params.row.sst_term == '' ? '-' : params.row.sst_term}`;
            },
        },
        {
            headerName: 'Date',
            field: "Date",
            headerClassName: "super-app-theme--header",
            minWidth: 110,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_test_date == null || params.row.sst_test_date == '' ? '-' : Moment(params.row.sst_test_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                    return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }
                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');
                return direction === 'asc' ? dateA - dateB : dateB - dateA;
            },
        },
        {
            headerName: 'Comment',
            field: "Comment",
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sst_comment == null || params.row.sst_comment == '' ? '-' : params.row.sst_comment}`;
            },
        },
        ...(isCentreAdmin ? [{
            field: "actions",
            type: "actions",
            headerName: "Action",
            headerClassName: "super-app-theme--header",
            width: 170,
            headerAlign: "left",
            renderCell: (params) => {
                const row = params.row;
                return (
                    <div className='d-flex gap-2 pad-12'>
                        <Button variant="outlined" onClick={() => handleEditSchoolTest(row)} className="primary-filled my-2">Edit</Button>
                        <Button variant="outlined-red" onClick={() => handleDeleteSchoolTest(row)} className="filled-danger my-2">Delete</Button>
                    </div>
                );
            }
        }] : []),
    ];

    /* ---------------- Student goals ---------------- */
    const basicSchemaGoal = yup.object().shape({
        sg_title: yup.string().trim().required("Goal is required."),
        sg_status: yup.string().nullable(),
        sg_subject: yup.string().nullable(),
        sg_target_date: yup.string().nullable(),
        sg_progress_notes: yup.string().nullable(),
    });

    const initialValuesGoal = {
        sg_title: "",
        sg_status: "",
        sg_subject: "",
        sg_target_date: "",
        sg_progress_notes: "",
        fk_student_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikGoal = useFormik({
        initialValues: initialValuesGoal,
        validationSchema: basicSchemaGoal,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            setIsGoalSubmitting(true);
            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: editingGoalKey ? "updateStudentGoal" : "createStudentGoal",
                    ...formValues,
                    pk_sg_key: editingGoalKey || undefined,
                    fk_cent_key: sessionStorage.getItem('key'),
                    updated_by: sessionStorage.getItem('key'),
                });

                if (response.data.success === true && response.data.data === 1) {
                    toast.success(editingGoalKey ? "Success! Goal updated." : "Success! Goal added.", { autoClose: 700 });
                    fetchData(Id);
                    setModalGoalShow(false);
                    setEditingGoalKey(null);
                    formikGoal.resetForm();
                } else {
                    toast.error("Failure! Unable to save goal. Try again later.", { autoClose: 700 });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failure! Unable to save goal. Try again later.", { autoClose: 700 });
            } finally {
                setIsGoalSubmitting(false);
            }
        },
    });

    const handleAddGoal = () => {
        setEditingGoalKey(null);
        formikGoal.resetForm();
        setModalGoalShow(true);
    };

    const handleEditGoal = (row) => {
        setEditingGoalKey(row.pk_sg_key);
        formikGoal.setValues({
            ...initialValuesGoal,
            sg_title: row.sg_title ?? "",
            sg_status: row.sg_status ?? "",
            sg_subject: row.sg_subject ?? "",
            sg_target_date: row.sg_target_date ?? "",
            sg_progress_notes: row.sg_progress_notes ?? "",
        });
        setModalGoalShow(true);
    };

    const handleDeleteGoal = (row) => {
        if (!row || !row.pk_sg_key) {
            toast.error("Sorry, goal key not found", { autoClose: 700 });
            return;
        }
        axios.post(BASE_URL + "API/api_index.php", {
            security_key: security_key,
            mode: "deleteStudentGoal",
            fk_cent_key: sessionStorage.getItem('key'),
            pk_sg_key: row.pk_sg_key
        }).then((responsedelete) => {
            if (responsedelete.data.data == 1) {
                fetchData(Id);
                toast.success("Success! Goal has been removed.", { autoClose: 700 });
            } else {
                toast.error("Failure! Unable to remove goal. Try again later", { autoClose: 700 });
            }
        }).catch(() => {
            toast.error("Failure! Unable to remove goal. Try again later", { autoClose: 700 });
        });
    };

    const columns_goals = [
        {
            headerName: 'Goal',
            field: "Goal",
            headerClassName: "super-app-theme--header",
            minWidth: 200,
            flex: 1.5,
            valueGetter: (params) => {
                return `${params.row.sg_title == null || params.row.sg_title == '' ? '-' : params.row.sg_title}`;
            },
        },
        {
            headerName: 'Subject',
            field: "Subject",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sg_subject == null || params.row.sg_subject == '' ? '-' : params.row.sg_subject}`;
            },
        },
        {
            headerName: 'Status',
            field: "Status",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sg_status == null || params.row.sg_status == '' ? '-' : params.row.sg_status}`;
            },
        },
        {
            headerName: 'Target Date',
            field: "TargetDate",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.sg_target_date == null || params.row.sg_target_date == '' ? '-' : Moment(params.row.sg_target_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                    return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }
                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');
                return direction === 'asc' ? dateA - dateB : dateB - dateA;
            },
        },
        {
            headerName: 'Progress Notes',
            field: "ProgressNotes",
            headerClassName: "super-app-theme--header",
            minWidth: 180,
            flex: 1.5,
            valueGetter: (params) => {
                return `${params.row.sg_progress_notes == null || params.row.sg_progress_notes == '' ? '-' : params.row.sg_progress_notes}`;
            },
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Action",
            headerClassName: "super-app-theme--header",
            width: 170,
            headerAlign: "left",
            renderCell: (params) => {
                const row = params.row;
                return (
                    <div className='d-flex gap-2 pad-12'>
                        <Button variant="outlined" onClick={() => handleEditGoal(row)} className="primary-filled my-2">Edit</Button>
                        <Button variant="outlined-red" onClick={() => handleDeleteGoal(row)} className="filled-danger my-2">Delete</Button>
                    </div>
                );
            }
        },
    ];


      function getDayWithSuffix(day) {
        if (day >= 11 && day <= 13) {
          // If the day is between 11 and 13, use 'th' suffix
          return day + 'th';
        }

        const lastDigit = day % 10;
        switch (lastDigit) {
          case 1:
            return day + 'st';
          case 2:
            return day + 'nd';
          case 3:
            return day + 'rd';
          default:
            return day + 'th';
        }
      }

      function getDayOfWeek(dayNumber) {
        const daysOfWeek = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"

        ];

        if (dayNumber >= 1 && dayNumber <= 7) {
          return daysOfWeek[dayNumber - 1];
        } else {
          return "Invalid day number";
        }
      }




      //wallet functionality start
      const offlinePaymentOption = OfflineModesOptions;
      const filteredOptions = parseInt(StudentData?.stripe_setting) === 1 &&
          parseInt(StudentData?.online_payment_verified) === 1 &&
          parseInt(StudentData?.card_status) === 1
        ? [...offlinePaymentOption, { value: '1', label: 'Pay via Stripe' }] : offlinePaymentOption; // past → add Offline



    const sumByType = (list = [], type) =>
                        list
                            .filter(
                            item =>
                                Number(item.wallet_transaction_type) === Number(type) &&
                                String(item.wallet_status) === '1'
                            )
                            .reduce(
                            (sum, item) => sum + Number(item.wallet_amount || 0),
                            0
                            );


      //feach the data wallet
       const fetchWalletData = async (id) => {

        try {
            const response = await axios.post(BASE_URL + 'API/api_index.php', {
                security_key: security_key,
                mode: "getStudentWallet",
                fk_student_key: id
            });

            if (response.data.success === true) {
                if (response.data.data.length > 0) {
                    setWalletData(response.data.data);

                }else{
                     setWalletData([]);
                }

            } else {
                setWalletData([]);
            }
        } catch (error) {
            console.error('Error fetching wallet data:', error);
        }

    };

    const columns_wallet = [
        {

            headerName: 'Date',
            field: "wallet_datetime",
            headerClassName: "super-app-theme--header",
            minWidth: 160,
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.wallet_datetime ? Moment(params.row.wallet_datetime).format('DD-MM-YYYY hh:mm A') : '-' }`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY hh:mm A');
                const dateB = Moment(valueB, 'DD-MM-YYYY hh:mm A');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },

        },
        {

            headerName: 'Accounting Date',
            field: "wallet_transaction_date",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.wallet_transaction_date ? Moment(params.row.wallet_transaction_date).format('DD-MM-YYYY') : '-' }`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                  // Handle sorting for dashes ("-"), place them at the end or beginning based on direction
                  return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }

                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');

                return direction === 'asc' ? dateA - dateB : dateB - dateA;
              },

        },
        {
            headerName: 'Description',
            field: "Description",
            headerClassName: "super-app-theme--header",
            minWidth: 250,
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.wallet_description ? params.row.wallet_description : '-'}`;
            },
        },
        {
            headerName: 'Transaction',
            field: "Transaction",
            headerClassName: "super-app-theme--header",
            minWidth: 70,
            flex: 1,
            valueGetter: (params) => {
                if (!params?.row?.wallet_transaction_type) return "-";

                const type = params.row.wallet_status == "0" && !params.row.fk_cpm_key ? params.row.stripe_status : params.row.wallet_transaction_type == "1" ? "Credit" : "Debit";

                const source =
                    params.row.pm_name ? params.row.pm_name : params.row.wallet_source == "4" ? "Deposit" : params.row.wallet_source != "3"
                    ? "Stripe"
                    : "Invoice";

                return `${type} - ${source}`;
            },
            renderCell: (params) => {
                const type = params.row.wallet_status == "0" && !params.row.fk_cpm_key ? params.row.stripe_status : params.row.wallet_transaction_type == "1" ? "Credit" : "Debit";

                const source = params.row.pm_name ? params.row.pm_name : params.row.wallet_source == "4" ? "Deposit" : params.row.wallet_source != "3"
                    ? "Stripe"
                    : "Invoice";

                const tooltipText = `${type} ${source}`;
                return (
                <div style={{ lineHeight: "18px" }} title={tooltipText} >
                    <div style={{ color: type === "Credit" ? "#16a34a" : type === params.row.stripe_status ? "#040d81ff" : "#dc2626", fontWeight: 600 }}>{type}</div>
                    <div style={{ fontSize: "10px", color: "#666" }}>{source}</div>
                </div>
                );
            }
        },
        {
            headerName: "Credit Amount(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "Credit Amount",
            headerClassName: "super-app-theme--header",
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.wallet_amount && params?.row?.wallet_transaction_type == '1' ? params.row.wallet_amount : '-'}`;
            },
        },
        {
            headerName: "Debit Amount(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "Debit Amount",
            headerClassName: "super-app-theme--header",
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.wallet_amount && params?.row?.wallet_transaction_type == '2' ? params.row.wallet_amount : '-'}`;
            },
        },
        {
            headerName: 'Action',
            field: "action",
            headerClassName: "super-app-theme--header",
            minWidth: 80,
            flex: 0.5,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <i
                    className="fa-solid fa-pen-to-square"
                    style={{ cursor: "pointer", color: "#040d81ff" }}
                    title="Edit"
                    onClick={() => handleEditWalletClick(params.row)}
                ></i>
            ),
        },
    ];

    /* ---------------------------------------------------------------------- */
    /*  COLUMNS  FOR PAUES                                                            */
    /* ---------------------------------------------------------------------- */

    
    const columns_pause = [
        {
            headerName: 'Start Date',
            field: "StartDate",
            headerClassName: "super-app-theme--header",
            minWidth: 110,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pause_start_date == null || params.row.pause_start_date == '' ? '-' : Moment(params.row.pause_start_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                    return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }
                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');
                return direction === 'asc' ? dateA - dateB : dateB - dateA;
            },
        },
        {
            headerName: 'End Date',
            field: "EndDate",
            headerClassName: "super-app-theme--header",
            minWidth: 110,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pause_end_date == null || params.row.pause_end_date == '' ? '-' : Moment(params.row.pause_end_date).format('DD-MM-YYYY')}`;
            },
            sortComparator: (valueA, valueB, rowA, rowB, direction) => {
                if (valueA === '-' || valueB === '-') {
                    return valueA === valueB ? 0 : valueA === '-' ? 1 : -1;
                }
                const dateA = Moment(valueA, 'DD-MM-YYYY');
                const dateB = Moment(valueB, 'DD-MM-YYYY');
                return direction === 'asc' ? dateA - dateB : dateB - dateA;
            },
        },
        {
            headerName: 'Session',
            field: "Session",
            headerClassName: "super-app-theme--header",
            minWidth: 130,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pause_apply_type == 1 ? 'All Sessions' : (params.row.sest_name || '-')}`;
            },
        },
        {
            headerName: 'Description',
            field: "Description",
            headerClassName: "super-app-theme--header",
            minWidth: 220,
            flex: 1.5,
            valueGetter: (params) => {
                return `${params.row.pause_description == null || params.row.pause_description == '' ? '-' : params.row.pause_description}`;
            },
        },
        {
            headerName: "Wallet Transfer Amount(" + (sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "WalletAmount",
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.pause_wallet_amount == null || params.row.pause_wallet_amount === '' ? '0.00' : parseFloat(params.row.pause_wallet_amount).toFixed(2)}`;
            },
        },
        {
            field: "actions",
            type: "actions",
            headerName: "Action",
            headerClassName: "super-app-theme--header",
            width: 140,
            headerAlign: "left",
            renderCell: (params) => {
                const row = params.row;

                const today = dayjs().startOf('day');
                const startDate = row.pause_start_date ? dayjs(row.pause_start_date).startOf('day') : null;
                const endDate = row.pause_end_date ? dayjs(row.pause_end_date).startOf('day') : null;

                // Edit hides once the pause has already ended (nothing left to adjust)
                const canEdit = !endDate || !today.isAfter(endDate);
                // Delete hides once the pause has already started (it's in effect / historical)
                const canDelete = !startDate || today.isBefore(startDate);

                return (
                    <div className='d-flex gap-2 pad-12'>
                        {canEdit && (
                            <i
                                className="fas fa-edit text-primary"
                                style={{ cursor: 'pointer' }}
                                title="Edit"
                                onClick={() => handleEditPause(row)}
                            ></i>
                        )}
                        {canDelete && (
                            <i
                                className="fas fa-trash-alt text-danger"
                                style={{ cursor: 'pointer' }}
                                title="Delete"
                                onClick={() => handleDeletePauseClick(row)}
                            ></i>
                        )}
                        {!canEdit && !canDelete && <span className="text-muted">-</span>}
                    </div>
                );
            }
        },
    ];

    //Add admin amount to wallet start
    const [showModalAddWallet, setModelAddWallet] = useState(false);
    const toggleModalAddWallet = () => setModelAddWallet(!showModalAddWallet);
    const [isAddWalletSubmitting, setIsAddWalletSubmitting] = useState(false);
    const [isEditWalletMode, setIsEditWalletMode] = useState(false); // NEW
    const timezoneIdentifier = sessionStorage.getItem("timezone_identifier");
    const todayWallet =
        new Date(Moment().tz(timezoneIdentifier).format("YYYY-MM-DDTHH:mm:ss")) ||
        new Date();

    const minTransactionDate = new Date();
    minTransactionDate.setFullYear(todayWallet.getFullYear() - 1);

    const maxTransactionDate = todayWallet;
    const basicSchemaAddWallet = yup.object().shape({
        wallet_amount: yup
            .number()
            .typeError("Amount must be a number")
            .min(0, "Minimum value 0 required")
            .max(2000, "Maximum value exceeded")
            .positive("Amount must be greater than 0.")
            .required("Amount is required."),

        //pk_cpm_key: yup.string().required('Payment Mode is required'),
        pk_cpm_key: yup.string().when([], {
            is: () => !isEditWalletMode,
            then: (schema) => schema.required('Payment Mode is required'),
            otherwise: (schema) => schema.notRequired(),
        }),
        wallet_transaction_date: yup
        .date()
        .transform((value, originalValue) => (originalValue === "" ? undefined : value))
        .typeError("Please enter a valid date")
        .min(minTransactionDate, "Date is too old")
        .max(maxTransactionDate, "Date cannot be in the future")
        .nullable()
        .notRequired(),

        wallet_description: yup
            .string()
            .trim("Description cannot contain only spaces")
            .required("Description is required"),
    });

    const initialValueAddWallet = {
        /*student wallet*/
        pk_stu_wallet_key: "", // NEW — needed for edit
        wallet_amount: "",
        pk_cpm_key: "",
        wallet_description: "",
        wallet_transaction_date: "",
        fk_stu_key: Id,
        wallet_payment_method: false,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikAddWallet = useFormik({
        initialValues: initialValueAddWallet,
        validationSchema: basicSchemaAddWallet,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            setIsAddWalletSubmitting(true);
            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: isEditWalletMode ? "updateStudentWalletEntry" : "addStudentWallet",
                    ...formValues,
                    updated_by: sessionStorage.getItem('key'),
                });

                if (response.data.success === true) {
                    if (response.data.data === 1) {
                        toast.success(
                            isEditWalletMode
                                ? "Wallet entry updated successfully."
                                : "The amount has been credited to the wallet successfully.",
                            { autoClose: 3000 }
                        );
                        fetchWalletData(Id);
                        setModelAddWallet(false);
                        formikAddWallet.resetForm();
                    } else if (response.data.data === 0) {
                        toast.error("Failed to process the wallet request. Please try again later.", { autoClose: 3000 });
                        fetchWalletData(Id);
                        setModelAddWallet(false);
                        formikAddWallet.resetForm();
                    } else {
                        toast.error(response.data.data, { autoClose: 3000 });
                    }
                } else {
                    toast.error("Failed to process the wallet request. Please try again later.", { autoClose: 3000 });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failed to process the wallet request. Please try again later.", { autoClose: 3000 });
            } finally {
                setIsAddWalletSubmitting(false);
            }
        },
    });

    const handleOpenAddWallet = () => {
        setIsEditWalletMode(false);
        formikAddWallet.resetForm();
        setModelAddWallet(true);
    };

    const handleEditWalletClick = (row) => {
        setIsEditWalletMode(true);
            const source = row.pm_name ? row.pm_name : row.wallet_source == "4" ? "Deposit" : row.wallet_source != "3"
                    ? "Stripe"
                    : "Invoice";
            const type = row.wallet_status == "0" && !row.fk_cpm_key ? row.stripe_status : row.wallet_transaction_type == "1" ? "Credit" : "Debit";

        const tooltipText = `${type} - ${source}`;
        formikAddWallet.setValues({
            pk_stu_wallet_key: row.pk_stu_wallet_key,
            wallet_amount: row.wallet_amount || "",
            pk_cpm_key: tooltipText || "",
            wallet_description: row.wallet_description || "",
            wallet_transaction_date: row.wallet_transaction_date
                ? Moment(row.wallet_transaction_date).format("YYYY-MM-DD")
                : "",
            fk_stu_key: Id,
            wallet_payment_method: false,
            fk_cent_key: sessionStorage.getItem('key'),
            created_by: sessionStorage.getItem('key'),
        });
        setModelAddWallet(true);
    };

    // Add to student wallet end

    // Refund from wallet start
    const [showModalRefundWallet, setModelRefundWallet] = useState(false);
    const toggleModalRefundWallet = () => setModelRefundWallet(!showModalRefundWallet);
    const [isRefundWalletSubmitting, setIsRefundWalletSubmitting] = useState(false);
    const maxRefundAmount = ((sumByType(wallet_data ?? [], 1) - sumByType(wallet_data ?? [], 2))).toFixed(2) || 0;

   // console.log("maxRefundAmount", maxRefundAmount);
    const basicSchemaRefundWallet = yup.object().shape({
        wallet_amount: yup
            .number()
            .typeError("Amount must be a number")
            .min(0, "Minimum value 0 required")
            .positive("Amount must be greater than 0.")
            .required("Amount is required.")
            .when("pk_cpm_key", {
                is: (value) => String(value) == "1",
                then: (schema) =>
                    schema.max(maxRefundAmount, "Maximum value exceeded"),
                otherwise: (schema) =>
                    schema.max(2000, "Maximum amount allowed is 2000"),
            }),

        pk_cpm_key: yup.string().required('Payment Mode is required'),
        wallet_transaction_date: yup
        .date()
        .transform((value, originalValue) => (originalValue === "" ? undefined : value))
        .typeError("Please enter a valid date")
        .min(minTransactionDate, "Date is too old")
        .max(maxTransactionDate, "Date cannot be in the future")
        .nullable()
        .notRequired(),

        wallet_description: yup
            .string()
            .trim("Description cannot contain only spaces")
            .required("Description is required"),
            // true = Payment Link, false = Direct Add
    });

    const initialValueRefundWallet = {
        /*student wallet*/
        wallet_amount: "",
        pk_cpm_key: "",
        wallet_description: "",
        wallet_transaction_date: "",
        fk_stu_key: Id,
        fk_cent_key: sessionStorage.getItem('key'),
        created_by: sessionStorage.getItem('key'),
    };

    const formikRefundWallet = useFormik({
        initialValues: initialValueRefundWallet,
        validationSchema: basicSchemaRefundWallet,
        enableReinitialize: true,
        // onSubmit,
        onSubmit: async (formValues) => {
            setIsRefundWalletSubmitting(true);
            try {
                const response = await axios.post(BASE_URL + "API/api_index.php", {
                    security_key: security_key,
                    mode: "refundFromStudentWallet",
                    ...formValues,
                });

                if (response.data.success === true) {
                    // Reset the form

                    if (response.data.data === 1) {
                        toast.success("The amount has been debited from the wallet successfully.", {
                            autoClose: 700, // 3 seconds in this example
                        });
                        fetchWalletData(Id);
                        setModelRefundWallet(false);
                        formikRefundWallet.resetForm();

                        setIsRefundWalletSubmitting(false); // Re-enable the submit button
                    } else {
                        toast.error("Failed to process the wallet request. Please try again later.", {
                            autoClose: 700, // 3 seconds in this example
                        });

                        setIsRefundWalletSubmitting(false); // Re-enable the submit button
                    }

                } else {

                    toast.error("Failed to process the wallet request. Please try again later.", {
                        autoClose: 700, // 3 seconds in this example
                    });

                    setIsRefundWalletSubmitting(false); // Re-enable the submit button

                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failed to process the wallet request. Please try again later.", {
                    autoClose: 700, // 3 seconds in this example
                });

                setIsRefundWalletSubmitting(false); // Re-enable the submit button

            } finally {
                setIsRefundWalletSubmitting(false); // Re-enable the submit button
            }

        },
    });



      //wallet functionality end

    //Download student profile as PDF start
    const generateStudentPDF = () => {
        downloadStudentProfilePdf({
            studentData: StudentData,
            secondaryParentData: StudentSecParData,
            studentAge: StudentAge,
            fieldDetails: fieldDetails,
        });
    };
    //Download student profile as PDF end


    
    /* ---------------------------------------------------------------------- */
    /* 4. FORMIK — add/edit pause form                                        */
    /* ---------------------------------------------------------------------- */
    const MIN_PAUSE_DATE = dayjs(); // today
    const MAX_PAUSE_DATE = dayjs().add(1, "year");
    const validationSchemaPause = yup.object().shape({
        // pause_start_date: yup
        //     .string()
        //     .required("Start date is required.")
        //     .test("is-valid-date", "Please enter a valid date.", function (value) {
        //         return value ? dayjs(value, "YYYY-MM-DD", true).isValid() : false;
        //     }),
        // pause_end_date: yup
        //     .string()
        //     .required("End date is required.")
        //     .test("is-valid-date", "Please enter a valid date.", function (value) {
        //         return value ? dayjs(value, "YYYY-MM-DD", true).isValid() : false;
        //     })
        //     .test("is-after-start", "End date must be on/after start date.", function (value) {
        //         const { pause_start_date } = this.parent;
        //         if (!pause_start_date || !value) return true;
        //         const start = dayjs(pause_start_date);
        //         const end = dayjs(value);
        //         if (!start.isValid() || !end.isValid()) return true;
        //         return isSameOrAfterDay(end, start);
        //     }),
        pause_start_date: yup
              .string()
              .required("Start date is required.")
              .test("is-valid-date", "Please enter a valid date.", function (value) {
                return value ? dayjs(value, "YYYY-MM-DD", true).isValid() : false;
              })
              .test("is-in-range", "Start date must be within the next 1 year.", function (value) {
                if (!value) return true; // required() already handles empty
                const d = dayjs(value);
                return d.isValid() && d.isSameOrAfter(MIN_PAUSE_DATE, "day") && d.isSameOrBefore(MAX_PAUSE_DATE, "day");
              }),
            pause_end_date: yup
              .string()
              .required("End date is required.")
              .test("is-valid-date", "Please enter a valid date.", function (value) {
                return value ? dayjs(value, "YYYY-MM-DD", true).isValid() : false;
              })
              .test("is-in-range", "End date must be within the next 1 year.", function (value) {
                if (!value) return true;
                const d = dayjs(value);
                return d.isValid() && d.isSameOrAfter(MIN_PAUSE_DATE, "day") && d.isSameOrBefore(MAX_PAUSE_DATE, "day");
              })
              .test("is-after-start", "End date must be on/after start date.", function (value) {
                const { pause_start_date } = this.parent;
                if (!pause_start_date || !value) return true;
                const start = dayjs(pause_start_date);
                const end = dayjs(value);
                if (!start.isValid() || !end.isValid()) return true; // other tests already flag this
                return end.isSameOrAfter(start, "day");
              }),
            
        pause_description: yup.string().required("Please enter a description."),
        pause_apply_type: yup.mixed().required("Please select an option."),
    });

    const initialValuesPause = {
        pause_start_date: "",
        pause_end_date: "",
        pause_description: "",
        pause_apply_type: 1,
        fk_sest_key: "",
    };

    // wallet-recalculation warning popup.
    async function submitEditPause() {
        if (!editingPauseKey) return;
        setIsPauseSubmitting(true);

        try {
            const response = await axios.post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                mode: "editStudentPause",
                pause_key: editingPauseKey,
                pause_start_date: formikPause.values.pause_start_date,
                pause_end_date: formikPause.values.pause_end_date,
                pause_description: formikPause.values.pause_description,
                pause_apply_type: formikPause.values.pause_apply_type,
                fk_sest_key: formikPause.values.fk_sest_key,
                updated_by: sessionStorage.getItem("key"),
            });

            const result = response?.data?.data;

            if (response.data.success === true && Number(result) === 1) {
                toast.success("Success! Pause updated.", { autoClose: 700 });
                await fetchPauseData(Id);
                setModalPauseShow(false);
                setShowPauseEditConfirm(false);
                setEditingPauseKey(null);
                setEditingPauseRow(null);
                formikPause.resetForm();
            } else if (Number(result) === 2) {
                toast.error("This date range overlaps an existing active pause.", { autoClose: 700 });
                setShowPauseEditConfirm(false);
            } else if (Number(result) === 3) {
                toast.error("Pause not found. It may have already been removed.", { autoClose: 700 });
                setShowPauseEditConfirm(false);
            } else {
                toast.error("Failure! Unable to update pause. Try again later.", { autoClose: 700 });
                setShowPauseEditConfirm(false);
            }
        } catch (error) {
            console.error("Error updating pause:", error);
            toast.error("Failure! Unable to update pause. Try again later.", { autoClose: 700 });
            setShowPauseEditConfirm(false);
        } finally {
            setIsPauseSubmitting(false);
        }
    }


    const formikPause = useFormik({
        initialValues: initialValuesPause,
        validationSchema: validationSchemaPause,
        enableReinitialize: true,
        onSubmit: async () => {
            setShowPauseEditConfirm(true);
        },
    });

    const handleEditPause = (row) => {
        setEditingPauseKey(row.pk_pause_key);
        setEditingPauseRow(row);
        formikPause.setValues({
            pause_start_date: row.pause_start_date ?? "",
            pause_end_date: row.pause_end_date ?? "",
            pause_description: row.pause_description ?? "",
            pause_apply_type: row.pause_apply_type ?? 1,
            fk_sest_key: row.fk_sest_key ?? "",
        });
        setModalPauseShow(true);
    };


    /* ---------------------------------------------------------------------- */
    /*  DELETE HANDLER FOR STUDENT PAUSE                                               */
    /* ---------------------------------------------------------------------- */

    function onSubmitDeletePause() {
        setIsPauseDeleteSubmitting(true);

        axios.post(BASE_URL + "API/api_index.php", {
            security_key: security_key,
            mode: "deleteStudentPause",
            pause_key: data_deletePause.pk_pause_key,
            deleted_by: sessionStorage.getItem('key'),
        }).then((response) => {
            if (Number(response?.data?.data) === 1) {
                setDeletePauseShow(false);
                fetchPauseData(Id);
                toast.success("Success! Pause has been removed.", { autoClose: 700 });
            } else {
                toast.error("Failure! Unable to remove pause. Try again later", { autoClose: 700 });
            }
            setIsPauseDeleteSubmitting(false);
        }).catch((error) => {
            console.error("Error deleting pause:", error);
            toast.error("Failure! Unable to remove pause. Try again later", { autoClose: 700 });
            setIsPauseDeleteSubmitting(false);
        });
    }

    return (
        <>
            {/* React alert */}
            <ToastContainer position="top-center" />


            <Modal show={showDelete} variant="danger">

                <Modal.Header>Parent</Modal.Header>

                <Modal.Body>
                <p>Are you sure? You want change to remove this parent? </p>

                </Modal.Body>
                <Modal.Footer className='pt-0'>
                <div className="mx-auto d-flex gap-2" >

                    <Button variant="contained" className="primary-gray" onClick={() => setDeleteShow(false)}>Cancel</Button>
                    <Button variant="contained" type='submit' className="primary-filled " disabled={isUserDeleteSubmitting} onClick={() => onSubmitDelete()} >Yes</Button>
                </div>

                </Modal.Footer>

            </Modal>

            <Modal show={showPrimary} variant="danger">

                <Modal.Header>Parent</Modal.Header>

                <Modal.Body>
                <p>Are you sure? You want change to primary account? </p>

                </Modal.Body>
                <Modal.Footer className='pt-0'>
                <div className="mx-auto d-flex gap-2" >

                    <Button variant="contained" className="primary-gray" onClick={() => setPrimaryShow(false)}>Cancel</Button>
                    <Button variant="contained" type='submit' className="primary-filled " disabled={isPrimarySubmitting} onClick={() => onSubmitPrimary()} >Yes</Button>
                </div>

                </Modal.Footer>

            </Modal>
            <Modal show={showDeletePause} variant="danger">
                <Modal.Header>Pause</Modal.Header>
                <Modal.Body>
                    <p>Are you sure? You want to remove this pause? Any invoice/wallet adjustments it made will be reversed.</p>
                </Modal.Body>
                <Modal.Footer className='pt-0'>
                    <div className="mx-auto d-flex gap-2">
                        <Button variant="contained" className="primary-gray" onClick={() => setDeletePauseShow(false)}>Cancel</Button>
                        <Button variant="contained" type='submit' className="primary-filled" disabled={isPauseDeleteSubmitting} onClick={() => onSubmitDeletePause()}>Yes</Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={modalPauseShow} 
                onHide={() => {setModalPauseShow(false);
                                    setEditingPauseKey(null);
                                    setEditingPauseRow(null);
                                    formikPause.resetForm();}}
                enforceFocus={false}
                variant="danger"
                style={{ zIndex: "1111" }}
                size="lg"
            // variant="danger" style={{ zIndex: "1111" }}
            >
                <Form autoComplete="off" onSubmit={formikPause.handleSubmit}>
                    <Modal.Header closeButton>
                        Edit Pause
                        {editingPauseRow && editingPauseRow.pause_description
                            ? " - " + editingPauseRow.pause_description
                            : ""}
                    </Modal.Header>

                    <Modal.Body>
                        <Row>
                            <Col lg="6" md="6" sm="12" className="position-relative mb-3">
                                <h6 className="form-lable required-field">Start Date</h6>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                       value={
                                            formikPause.values.pause_start_date
                                            ? dayjs(formikPause.values.pause_start_date)
                                            : null
                                        }
                                        onChange={(date) => {
                                            const valid = date && dayjs(date).isValid();
                                            formikPause.setFieldValue(
                                            "pause_start_date",
                                            valid ? dayjs(date).format("YYYY-MM-DD") : ""
                                            );
                                            formikPause.handleBlur;
                                        }}
                                        
                                        minDate={MIN_PAUSE_DATE}
                                        maxDate={MAX_PAUSE_DATE}
                                        format="DD-MM-YYYY"
                                        slotProps={{
                                            textField: {
                                            size: "small",
                                            onBlur: () => formikPause.handleBlur,
                                            },
                                        }}
                                        className="w-100"
                                    />
                                </LocalizationProvider>
                                {formikPause.errors.pause_start_date && formikPause.touched.pause_start_date && (
                                    <span className="error">{formikPause.errors.pause_start_date}</span>
                                )}
                            </Col>

                            <Col lg="6" md="6" sm="12" className="position-relative mb-3">
                                <h6 className="form-lable required-field">End Date</h6>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={
                                            formikPause.values.pause_end_date
                                                ? dayjs(formikPause.values.pause_end_date)
                                                : null
                                        }
                                        onChange={(date) => {
                                            const valid = date && dayjs(date).isValid();
                                            formikPause.setFieldValue(
                                            "pause_end_date",
                                            valid ? dayjs(date).format("YYYY-MM-DD") : ""
                                            );
                                            formikPause.handleBlur;
                                        }}
                                        minDate={
                                            formikPause.values.pause_start_date
                                                ? dayjs(formikPause.values.pause_start_date)
                                                : MIN_PAUSE_DATE
                                        }
                                        maxDate={MAX_PAUSE_DATE}
                                        format="DD-MM-YYYY"
                                        slotProps={{
                                            textField: {
                                            size: "small",
                                            onBlur: () => formikPause.handleBlur,
                                            },
                                        }}
                                        className="w-100"
                                    />
                                </LocalizationProvider>
                                {formikPause.errors.pause_end_date && formikPause.touched.pause_end_date && (
                                    <span className="error">{formikPause.errors.pause_end_date}</span>
                                )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className="position-relative mb-3">
                                <h6 className="form-lable required-field">Description</h6>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="pause_description"
                                    value={formikPause.values.pause_description}
                                    onChange={formikPause.handleChange}
                                    onBlur={formikPause.handleBlur}
                                    className={
                                        formikPause.errors.pause_description && formikPause.touched.pause_description
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikPause.errors.pause_description && formikPause.touched.pause_description && (
                                    <span className="error">{formikPause.errors.pause_description}</span>
                                )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className="position-relative mb-2">
                                <h6 className="form-lable required-field">Apply To</h6>
                                <Form.Check
                                    type="radio"
                                    id="pause_edit_apply_all"
                                    label="Apply to all sessions"
                                    checked={formikPause.values.pause_apply_type == 1}
                                    onChange={() => formikPause.setFieldValue("pause_apply_type", 1)}
                                />
                                <Form.Check
                                    type="radio"
                                    id="pause_edit_apply_particular"
                                    label={
                                        "Apply to this session only" +
                                        (editingPauseRow && editingPauseRow.sest_name ? ` (${editingPauseRow.sest_name})` : "")
                                    }
                                    checked={formikPause.values.pause_apply_type == 2}
                                    onChange={() => formikPause.setFieldValue("pause_apply_type", 2)}
                                />
                                {formikPause.errors.pause_apply_type && formikPause.touched.pause_apply_type && (
                                    <div className="error">{formikPause.errors.pause_apply_type}</div>
                                )}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer className="pt-0">
                        <div className="mx-auto d-flex gap-2">
                            <Button
                                variant="contained"
                                className="primary-gray"
                                onClick={() => {
                                    setModalPauseShow(false);
                                    setEditingPauseKey(null);
                                    setEditingPauseRow(null);
                                    formikPause.resetForm();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                className="primary-filled"
                                disabled={isPauseSubmitting}
                            >
                                Save Changes
                            </Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showPauseEditConfirm} variant="danger" style={{ zIndex: "1112" }}>
                <Modal.Header>Confirm Changes</Modal.Header>

                <Modal.Body>
                    <p className="mb-0">
                        Changing this pause will reverse its original invoice/wallet adjustment and
                        recalculate it for the new dates. If any session in the new range has already
                        been paid, that amount goes to the student's wallet — it will not be moved
                        back to the original payment source. Continue?
                    </p>
                </Modal.Body>
                <Modal.Footer className="pt-0">
                    <div className="mx-auto d-flex gap-2">
                        <Button
                            variant="contained"
                            className="primary-gray"
                            onClick={() => setShowPauseEditConfirm(false)}
                            disabled={isPauseSubmitting}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            type="button"
                            className="primary-filled"
                            disabled={isPauseSubmitting}
                            onClick={() => submitEditPause()}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalPass} onHide={toggleModalpass} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Manage Login</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formik3.handleSubmit}>
                    <Modal.Body>

                        {/* --------------Date--------------- */}

                        <div className='section-heading border-bottom pb-3 mb-3'>
                            <h6 className='mb-0'>Parent App Login</h6>
                        </div>
                        <Row>


                            {/* --------------Student Username--------------- */}

                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Username</h6>
                                <Form.Control type="text"
                                    name="pa_login_id"
                                    //readOnly
                                    value={formik3.values.pa_login_id}
                                    onChange={formik3.handleChange}
                                    // onBlur={handleBlur}
                                    id="pa_login_id"
                                    onBlur={formik3.handleBlur}
                                    className={formik3.errors.pa_login_id && formik3.touched.pa_login_id ? "input-error" : ""}
                                />
                                {formik3.errors.pa_login_id && formik3.touched.pa_login_id && <p className="error">{formik3.errors.pa_login_id}</p>}
                            </Col>

                            {/* --------------Student Password--------------- */}


                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Password</h6>
                                <Form.Control type={passwordVisible ? "text" : "password"}

                                    value={formik3.values.pa_password}
                                    onChange={formik3.handleChange}
                                    onBlur={formik3.handleBlur}
                                    id="pa_password"
                                    className={formik3.errors.pa_password && formik3.touched.pa_password ? "input-error" : ""}
                                    autocomplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="password-toggle-button pswicon" title="show / hide"
                                >
                                    {passwordVisible ? <FiEye /> : <FiEyeOff />}

                                </button>
                                {formik3.errors.pa_password && formik3.touched.pa_password && <p className="error">{formik3.errors.pa_password}</p>}
                            </Col>


                            {/* --------------Student Confirm Password--------------- */}

                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Confirm Password</h6>
                                <Form.Control type={ConpasswordVisible ? "text" : "password"}
                                    value={formik3.values.pa_conform_password}
                                    onChange={formik3.handleChange}
                                    onBlur={formik3.handleBlur}
                                    id="pa_conform_password"
                                    className={formik3.errors.pa_conform_password && formik3.touched.pa_conform_password ? "input-error" : ""}
                                    autocomplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={toggleConPasswordVisibility}
                                    className="password-toggle-button pswicon" title="show / hide"
                                >
                                    {ConpasswordVisible ? <FiEye /> : <FiEyeOff />}

                                </button>
                                {formik3.errors.pa_conform_password && formik3.touched.pa_conform_password && <p className="error">{formik3.errors.pa_conform_password}</p>}
                            </Col>

                        </Row>


                    </Modal.Body>
                    <Modal.Footer>

                        <div className="mx-auto d-flex gap-2" >

                            <Button variant="contained" className="primary-gray" onClick={toggleModalpass}>Cancel</Button>
                            <Button variant="contained" type='submit' className="primary-filled " disabled={isSubmittingPass}>Submit</Button>

                        </div>

                    </Modal.Footer>
                </Form>
            </Modal>

          {/* Addtional parent login */}

            <Modal show={showModalPass2} onHide={toggleModalpass2} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Manage Login</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formik4.handleSubmit}>
                    <Modal.Body>

                        {/* --------------Date--------------- */}

                        <div className='section-heading border-bottom pb-3 mb-3'>
                            <h6 className='mb-0'>Parent App Login</h6>
                        </div>
                        <Row>


                            {/* --------------Student Username--------------- */}

                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Username</h6>
                                <Form.Control type="text"
                                    name="pa_login_id"
                                    //readOnly
                                    value={formik4.values.pa_login_id}
                                    onChange={formik4.handleChange}
                                    // onBlur={handleBlur}
                                    id="pa_login_id"
                                    onBlur={formik4.handleBlur}
                                    className={formik4.errors.pa_login_id && formik4.touched.pa_login_id ? "input-error" : ""}
                                />
                                {formik4.errors.pa_login_id && formik4.touched.pa_login_id && <p className="error">{formik4.errors.pa_login_id}</p>}
                            </Col>

                            {/* --------------Student Password--------------- */}


                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Password</h6>
                                <Form.Control type={passwordVisible2 ? "text" : "password"}

                                    value={formik4.values.pa_password}
                                    onChange={formik4.handleChange}
                                    onBlur={formik4.handleBlur}
                                    id="pa_password"
                                    className={formik4.errors.pa_password && formik4.touched.pa_password ? "input-error" : ""}
                                    autocomplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility2}
                                    className="password-toggle-button pswicon" title="show / hide"
                                >
                                    {passwordVisible2 ? <FiEye /> : <FiEyeOff />}

                                </button>
                                {formik4.errors.pa_password && formik4.touched.pa_password && <p className="error">{formik4.errors.pa_password}</p>}
                            </Col>


                            {/* --------------Student Confirm Password--------------- */}

                            <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Confirm Password</h6>
                                <Form.Control type={ConpasswordVisible ? "text" : "password"}
                                    value={formik4.values.pa_conform_password}
                                    onChange={formik4.handleChange}
                                    onBlur={formik4.handleBlur}
                                    id="pa_conform_password"
                                    className={formik4.errors.pa_conform_password && formik4.touched.pa_conform_password ? "input-error" : ""}
                                    autocomplete="off"
                                />
                                <button
                                    type="button"
                                    onClick={toggleConPasswordVisibility}
                                    className="password-toggle-button pswicon" title="show / hide"
                                >
                                    {ConpasswordVisible ? <FiEye /> : <FiEyeOff />}

                                </button>
                                {formik4.errors.pa_conform_password && formik4.touched.pa_conform_password && <p className="error">{formik4.errors.pa_conform_password}</p>}
                            </Col>

                        </Row>


                    </Modal.Body>
                    <Modal.Footer>

                        <div className="mx-auto d-flex gap-2" >

                            <Button variant="contained" className="primary-gray" onClick={toggleModalpass2}>Cancel</Button>
                            <Button variant="contained" type='submit' className="primary-filled " disabled={isSubmittingPass2}>Submit</Button>

                        </div>

                    </Modal.Footer>
                </Form>
            </Modal>


            {/* <Modal show={showModalAddWallet} onHide={toggleModalAddWallet} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Add to Wallet</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikAddWallet.handleSubmit}>
                    <Modal.Body>
                        <Row>


                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="wallet_amount"
                                    step="0.01"
                                    min="0"          // minimum allowed value
                                    max="2000"     // maximum allowed value
                                    name="wallet_amount"
                                    value={formikAddWallet.values.wallet_amount}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    className={formikAddWallet.errors.wallet_amount && formikAddWallet.touched.wallet_amount ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_amount && formikAddWallet.touched.wallet_amount && <p className="error">{formikAddWallet.errors.wallet_amount}</p>}
                            </Col>
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Payment Mode {['top'].map((placement) => (
                                    <OverlayTrigger
                                        key={placement}
                                        placement={placement}
                                        overlay={
                                        <Tooltip id={`tooltip-${placement}`} className="custom-tooltip">
                                            The super admin can add, edit, and delete payment mode form.
                                        </Tooltip>
                                        }
                                    >
                                        <Button variant="secondary" className="no-bdr">
                                        <i class="fa-solid fa-info-circle ml-2 mr-2 mt-1"></i>
                                        </Button>
                                    </OverlayTrigger>

                                ))}</h6>
                                <Select menuPlacement="auto" options={filteredOptions}
                                name="pk_cpm_key"
                                value={formikAddWallet.values.pk_cpm_key['value']}
                                id="pk_cpm_key"
                                onChange={(selectedOption) => {
                                    const event = {
                                    target: {
                                        name: "pk_cpm_key",
                                        value: selectedOption["value"],
                                    },
                                    };
                                    formikAddWallet.handleChange(event);
                                }}
                                onBlur={(event) => {
                                    formikAddWallet.handleBlur(event);
                                    formikAddWallet.setTouched({ ...formikAddWallet.touched, pk_cpm_key: true });
                                }}
                                className={formikAddWallet.errors.pk_cpm_key && formikAddWallet.touched.pk_cpm_key ? "input-error" : ""} />
                                {formikAddWallet.errors.pk_cpm_key && formikAddWallet.touched.pk_cpm_key && <span className="error">{formikAddWallet.errors.pk_cpm_key}</span>}
                            </Col>
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable">Accounting Date</h6>
                                <Form.Control
                                    type="date"
                                    id="wallet_transaction_date"
                                    name="wallet_transaction_date"
                                    min={minTransactionDate.toISOString().slice(0, 10)}
                                    max={maxTransactionDate.toISOString().slice(0, 10)}
                                    value={formikAddWallet.values.wallet_transaction_date}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    className={formikAddWallet.errors.wallet_transaction_date && formikAddWallet.touched.wallet_transaction_date ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_transaction_date && formikAddWallet.touched.wallet_transaction_date &&
                                    <p className="error">{formikAddWallet.errors.wallet_transaction_date}</p>}
                            </Col>
                            <Col lg="12" md="12" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Description</h6>
                                <Form.Control as="textarea" rows={4}
                                    value={formikAddWallet.values.wallet_description}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    id="wallet_description"
                                    className={formikAddWallet.errors.wallet_description && formikAddWallet.touched.wallet_description ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_description && formikAddWallet.touched.wallet_description && <p className="error">{formikAddWallet.errors.wallet_description}</p>}
                            </Col>


                        </Row>


                    </Modal.Body>
                    <Modal.Footer>

                        <div className="mx-auto d-flex gap-2" >

                            <Button variant="contained" className="primary-gray" onClick={toggleModalAddWallet}>Cancel</Button>
                            <Button variant="contained" type='submit' className="primary-filled " disabled={isAddWalletSubmitting}>Submit</Button>

                        </div>

                    </Modal.Footer>
                </Form>
            </Modal> */}

            <Modal show={showModalAddWallet} onHide={toggleModalAddWallet} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>{isEditWalletMode ? "Edit Wallet Entry" : "Add to Wallet"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikAddWallet.handleSubmit}>
                    <Modal.Body>
                        <Row>

                            {/* -------------- Amount --------------- */}
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className={`form-lable ${!isEditWalletMode ? "required-field" : ""}`}>Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="wallet_amount"
                                    step="0.01"
                                    min="0"
                                    max="2000"
                                    name="wallet_amount"
                                    disabled={isEditWalletMode}
                                    value={formikAddWallet.values.wallet_amount}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    className={formikAddWallet.errors.wallet_amount && formikAddWallet.touched.wallet_amount ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_amount && formikAddWallet.touched.wallet_amount && <p className="error">{formikAddWallet.errors.wallet_amount}</p>}
                            </Col>

                            {/* -------------- Payment Mode --------------- */}
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className={`form-lable ${!isEditWalletMode ? "required-field" : ""}`}>Payment Mode {['top'].map((placement) => (
                                    <OverlayTrigger
                                        key={placement}
                                        placement={placement}
                                        overlay={
                                            <Tooltip id={`tooltip-${placement}`} className="custom-tooltip">
                                                The super admin can add, edit, and delete payment mode form.
                                            </Tooltip>
                                        }
                                    >
                                        <Button variant="secondary" className="no-bdr">
                                            <i class="fa-solid fa-info-circle ml-2 mr-2 mt-1"></i>
                                        </Button>
                                    </OverlayTrigger>
                                ))}</h6>
                                {isEditWalletMode ? ( 
                                    <Form.Control
                                        type="text"
                                        id="pk_cpm_key"
                                        name="pk_cpm_key"
                                        disabled={isEditWalletMode}
                                        value={formikAddWallet.values.pk_cpm_key}
                                        onChange={formikAddWallet.handleChange}
                                        onBlur={formikAddWallet.handleBlur}
                                        className={formikAddWallet.errors.pk_cpm_key && formikAddWallet.touched.pk_cpm_key ? "input-error" : ""}
                                    />
                                ) :(
                                <Select menuPlacement="auto" options={filteredOptions}
                                    name="pk_cpm_key"
                                    value={filteredOptions.find(opt => opt.value === formikAddWallet.values.pk_cpm_key) || null}
                                    id="pk_cpm_key"
                                    isDisabled={isEditWalletMode}
                                    onChange={(selectedOption) => {
                                        const event = {
                                            target: {
                                                name: "pk_cpm_key",
                                                value: selectedOption["value"],
                                            },
                                        };
                                        formikAddWallet.handleChange(event);
                                    }}
                                    onBlur={(event) => {
                                        formikAddWallet.handleBlur(event);
                                        formikAddWallet.setTouched({ ...formikAddWallet.touched, pk_cpm_key: true });
                                    }}
                                    className={formikAddWallet.errors.pk_cpm_key && formikAddWallet.touched.pk_cpm_key ? "input-error" : ""} />
                                )}
                                {formikAddWallet.errors.pk_cpm_key && formikAddWallet.touched.pk_cpm_key && <span className="error">{formikAddWallet.errors.pk_cpm_key}</span>}
                            </Col>

                            {/* -------------- Accounting Date (always editable) --------------- */}
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable">Accounting Date</h6>
                                <Form.Control
                                    type="date"
                                    id="wallet_transaction_date"
                                    name="wallet_transaction_date"
                                    min={minTransactionDate.toISOString().slice(0, 10)}
                                    max={maxTransactionDate.toISOString().slice(0, 10)}
                                    value={formikAddWallet.values.wallet_transaction_date}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    className={formikAddWallet.errors.wallet_transaction_date && formikAddWallet.touched.wallet_transaction_date ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_transaction_date && formikAddWallet.touched.wallet_transaction_date &&
                                    <p className="error">{formikAddWallet.errors.wallet_transaction_date}</p>}
                            </Col>

                            {/* -------------- Description (always editable) --------------- */}
                            <Col lg="12" md="12" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Description</h6>
                                <Form.Control as="textarea" rows={4}
                                    value={formikAddWallet.values.wallet_description}
                                    onChange={formikAddWallet.handleChange}
                                    onBlur={formikAddWallet.handleBlur}
                                    id="wallet_description"
                                    name="wallet_description"
                                    className={formikAddWallet.errors.wallet_description && formikAddWallet.touched.wallet_description ? "input-error" : ""}
                                />
                                {formikAddWallet.errors.wallet_description && formikAddWallet.touched.wallet_description && <p className="error">{formikAddWallet.errors.wallet_description}</p>}
                            </Col>

                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="mx-auto d-flex gap-2" >
                            <Button variant="contained" className="primary-gray" onClick={toggleModalAddWallet}>Cancel</Button>
                            <Button variant="contained" type='submit' className="primary-filled" disabled={isAddWalletSubmitting}>Submit</Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
            <Modal show={showModalRefundWallet} onHide={toggleModalRefundWallet} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered >
                <Modal.Header closeButton>
                    <Modal.Title>Deduct from Wallet</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikRefundWallet.handleSubmit}>
                    <Modal.Body>
                        <Row>


                            {/* -------------- Amount --------------- */}

                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="wallet_amount"
                                    step="0.01"
                                    min="0"          // minimum allowed value
                                    //max={maxRefundAmount}    // maximum allowed value
                                    name="wallet_amount"
                                    value={formikRefundWallet.values.wallet_amount}
                                    onChange={formikRefundWallet.handleChange}
                                    onBlur={formikRefundWallet.handleBlur}
                                    className={formikRefundWallet.errors.wallet_amount && formikRefundWallet.touched.wallet_amount ? "input-error" : ""}
                                />
                                {formikRefundWallet.errors.wallet_amount && formikRefundWallet.touched.wallet_amount && <p className="error">{formikRefundWallet.errors.wallet_amount}</p>}
                            </Col>
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Payment Mode {['top'].map((placement) => (
                                    <OverlayTrigger
                                        key={placement}
                                        placement={placement}
                                        overlay={
                                        <Tooltip id={`tooltip-${placement}`} className="custom-tooltip">
                                            The super admin can add, edit, and delete payment mode form.
                                        </Tooltip>
                                        }
                                    >
                                        <Button variant="secondary" className="no-bdr">
                                        <i class="fa-solid fa-info-circle ml-2 mr-2 mt-1"></i>
                                        </Button>
                                    </OverlayTrigger>

                                ))}</h6>
                                <Select menuPlacement="auto" 
                                options={[
                                    { value: 1, label: "Transfer to Deposit" },
                                    ...OfflineModesOptions
                                ]}
                                name="pk_cpm_key"
                                value={formikRefundWallet.values.pk_cpm_key['value']}
                                id="pk_cpm_key"
                                onChange={(selectedOption) => {
                                    const event = {
                                    target: {
                                        name: "pk_cpm_key",
                                        value: selectedOption["value"],
                                    },
                                    };
                                    formikRefundWallet.handleChange(event);
                                }}
                                onBlur={(event) => {
                                    formikRefundWallet.handleBlur(event);
                                    formikRefundWallet.setTouched({ ...formikRefundWallet.touched, pk_cpm_key: true });
                                }}
                                className={formikRefundWallet.errors.pk_cpm_key && formikRefundWallet.touched.pk_cpm_key ? "input-error" : ""} />
                                {formikRefundWallet.errors.pk_cpm_key && formikRefundWallet.touched.pk_cpm_key && <span className="error">{formikRefundWallet.errors.pk_cpm_key}</span>}
                            </Col>
                            <Col lg="4" md="4" sm="12" className='position-relative'>
                                <h6 className="form-lable">Accounting Date</h6>
                                <Form.Control
                                    type="date"
                                    id="wallet_transaction_date"
                                    name="wallet_transaction_date"
                                    min={minTransactionDate.toISOString().slice(0, 10)}
                                    max={maxTransactionDate.toISOString().slice(0, 10)}
                                    value={formikRefundWallet.values.wallet_transaction_date}
                                    onChange={formikRefundWallet.handleChange}
                                    onBlur={formikRefundWallet.handleBlur}
                                    className={formikRefundWallet.errors.wallet_transaction_date && formikRefundWallet.touched.wallet_transaction_date ? "input-error" : ""}
                                />
                                {formikRefundWallet.errors.wallet_transaction_date && formikRefundWallet.touched.wallet_transaction_date &&
                                    <p className="error">{formikRefundWallet.errors.wallet_transaction_date}</p>}
                            </Col>
                            <Col lg="12" md="12" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Description</h6>
                                <Form.Control as="textarea" rows={4}
                                    value={formikRefundWallet.values.wallet_description}
                                    onChange={formikRefundWallet.handleChange}
                                    onBlur={formikRefundWallet.handleBlur}
                                    id="wallet_description"
                                    className={formikRefundWallet.errors.wallet_description && formikRefundWallet.touched.wallet_description ? "input-error" : ""}
                                />
                                {formikRefundWallet.errors.wallet_description && formikRefundWallet.touched.wallet_description && <p className="error">{formikRefundWallet.errors.wallet_description}</p>}
                            </Col>


                        </Row>


                    </Modal.Body>
                    <Modal.Footer>

                        <div className="mx-auto d-flex gap-2" >

                            <Button variant="contained" className="primary-gray" onClick={toggleModalRefundWallet}>Cancel</Button>
                            <Button variant="contained" type='submit' className="primary-filled " disabled={isRefundWalletSubmitting}>Submit</Button>

                        </div>

                    </Modal.Footer>
                </Form>
            </Modal>
            <div className='page-wrapper'>

                <Modal
                    show={modalShow} onHide={() => setModalShow(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h5 className='page-title'> Student Notes </h5>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            {/* --------------Date--------------- */}
                            <Row>


                                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Date</h6>
                                    {/* <Form.Control
                                        type="date"

                                        value={values.sn_date}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="sn_date"
                                        className={errors.sn_date && touched.sn_date ? "input-error" : ""}
                                    /> */}
                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker  views={['year', 'month', 'day']}
                                            value={dayjs(values.sn_date, 'YYYY-MM-DD')}
                                            onChange={(date) =>  {
                                                const event = {
                                                target: {
                                                    name: "sn_date",
                                                    value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : date,
                                                },
                                                };
                                                handleChange(event);
                                            }}
                                            onBlur={(event) => {
                                                handleBlur(event);
                                                setTouched({ ...touched, sn_date: true });
                                            }}
                                            name="sn_date"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small',
                                                    id: 'sn_date',
                                                },
                                                }}
                                            className={errors.sn_date && touched.sn_date ? "input-error w-100" : "w-100"}
                                            minDate={dayjs()}
                                            // maxDate={dayjs()}
                                            format="DD-MM-YYYY"
 />
                                    </LocalizationProvider>
                                    {errors.sn_date && touched.sn_date && <span className="error">{errors.sn_date}</span>}
                                </Col>


                                {/* --------------Category--------------- */}

                                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Subject</h6>
                                    <Select menuPlacement="auto" options={options_subject}
                                        name="sn_category"
                                        value={values.sn_category['value']}
                                        id="sn_category"
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: "sn_category",
                                                    value: selectedOption["value"],
                                                },
                                            };
                                            handleChange(event);
                                        }}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                            setTouched({ ...touched, sn_category: true });
                                        }}
                                        className={errors.sn_category && touched.sn_category ? "input-error" : ""} />
                                    {errors.sn_category && touched.sn_category && <span className="error">{errors.sn_category}</span>}
                                </Col>


                                {/* --------------Notes--------------- */}

                                <Col lg="12" md="12" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Note</h6>
                                    <Form.Control as="textarea" rows={3}

                                        value={values.sn_note}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        id="sn_note"
                                        className={errors.sn_note && touched.sn_note ? "input-error" : ""}
                                    />
                                    {errors.sn_note && touched.sn_note && <p className="error">{errors.sn_note}</p>}
                                </Col>


                                {/* --------------Notes check--------------- */}

                                {/* --------------Contact Checkbox--------------- */}
                                <Col lg="12" md="12" sm="12" className='position-relative'>

                                    <Form.Check // prettier-ignore
                                        type="checkbox"
                                        label="Critical (Anyways on Top)"
                                        name="sn_is_critical"
                                        id="sn_is_critical"
                                        checked={values.sn_is_critical}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.sn_is_critical && touched.sn_is_critical && <p className="error">{errors.sn_is_critical}</p>}
                                </Col>

                            </Row>
                        </Modal.Body>

                        <Modal.Footer>

                            <div className="mx-auto d-flex gap-2" >

                                <Button variant="contained" className="primary-gray" onClick={() => setModalShow(false)}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={isSubmitting}>Save</Button>
                            </div>

                        </Modal.Footer>
                    </Form>
                </Modal>

                <Modal
                    show={modalPaymentNotesShow} onHide={() => setModalPaymentNotesShow(false)}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form autoComplete="off" onSubmit={formikPaymentNotes.handleSubmit} ref={formRef}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h5 className='page-title'> Payment Notes </h5>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            {/* --------------Date--------------- */}
                            <Row>


                                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Date</h6>

                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker  views={['year', 'month', 'day']}
                                            value={dayjs(formikPaymentNotes.values.pn_date, 'YYYY-MM-DD')}
                                            onChange={(date) =>  {
                                                const event = {
                                                target: {
                                                    name: "pn_date",
                                                    value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : date,
                                                },
                                                };
                                                formikPaymentNotes.handleChange(event);
                                            }}
                                            onBlur={(event) => {
                                                formikPaymentNotes.handleBlur(event);
                                                formikPaymentNotes.setTouched({ ...touched, pn_date: true });
                                            }}
                                            name="sn_date"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small',
                                                    id: 'pn_date',
                                                },
                                                }}
                                            className={formikPaymentNotes.errors.pn_date && formikPaymentNotes.touched.pn_date ? "input-error w-100" : "w-100"}
                                            minDate={dayjs().subtract(1, 'year')}
                                            maxDate={dayjs().add(1, 'year')}
                                            format="DD-MM-YYYY"
                                        />
                                    </LocalizationProvider>
                                    {formikPaymentNotes.errors.pn_date && formikPaymentNotes.touched.pn_date && <span className="error">{formikPaymentNotes.errors.pn_date}</span>}
                                </Col>

                                {/* --------------Notes--------------- */}

                                <Col lg="12" md="12" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Note</h6>
                                    <Form.Control as="textarea" rows={3}

                                        value={formikPaymentNotes.values.pn_note}
                                        onChange={formikPaymentNotes.handleChange}
                                        onBlur={formikPaymentNotes.handleBlur}
                                        id="pn_note"
                                        className={formikPaymentNotes.errors.pn_note && formikPaymentNotes.touched.pn_note ? "input-error" : ""}
                                    />
                                    {formikPaymentNotes.errors.pn_note && formikPaymentNotes.touched.pn_note && <p className="error">{formikPaymentNotes.errors.pn_note}</p>}
                                </Col>


                                {/* --------------Notes check--------------- */}


                            </Row>
                        </Modal.Body>

                        <Modal.Footer>

                            <div className="mx-auto d-flex gap-2" >

                                <Button variant="contained" className="primary-gray" onClick={() => setModalPaymentNotesShow(false)}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={isPaymentNotesSubmitting}>Save</Button>
                            </div>

                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* --------------School Test Score Add / Edit Modal--------------- */}
                <Modal
                    show={modalSchoolTestShow}
                    onHide={() => { setModalSchoolTestShow(false); setEditingSchoolTestKey(null); }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form autoComplete="off" onSubmit={formikSchoolTest.handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h5 className='page-title'>{editingSchoolTestKey ? 'Edit Test Score' : 'Add Test Score'}</h5>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Row>
                                {/* --------------Test name--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Test Name</h6>
                                    <Form.Control
                                        type="text"
                                        value={formikSchoolTest.values.sst_test_name}
                                        onChange={formikSchoolTest.handleChange}
                                        onBlur={formikSchoolTest.handleBlur}
                                        id="sst_test_name"
                                        name="sst_test_name"
                                        className={formikSchoolTest.errors.sst_test_name && formikSchoolTest.touched.sst_test_name ? "input-error" : ""}
                                    />
                                    {formikSchoolTest.errors.sst_test_name && formikSchoolTest.touched.sst_test_name && <span className="error">{formikSchoolTest.errors.sst_test_name}</span>}
                                </Col>

                                {/* --------------Subject--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable">Subject</h6>
                                    <Form.Control
                                        type="text"
                                        value={formikSchoolTest.values.sst_subject}
                                        onChange={formikSchoolTest.handleChange}
                                        onBlur={formikSchoolTest.handleBlur}
                                        id="sst_subject"
                                        name="sst_subject"
                                    />
                                </Col>

                                {/* --------------Date--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Test Date</h6>
                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker views={['year', 'month', 'day']}
                                            value={formikSchoolTest.values.sst_test_date ? dayjs(formikSchoolTest.values.sst_test_date, 'YYYY-MM-DD') : null}
                                            onChange={(date) => {
                                                const event = {
                                                    target: {
                                                        name: "sst_test_date",
                                                        value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : "",
                                                    },
                                                };
                                                formikSchoolTest.handleChange(event);
                                            }}
                                            onBlur={() => {
                                                formikSchoolTest.setFieldTouched('sst_test_date', true);
                                            }}
                                            name="sst_test_date"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small', id: 'sst_test_date' },
                                            }}
                                            className={formikSchoolTest.errors.sst_test_date && formikSchoolTest.touched.sst_test_date ? "input-error w-100" : "w-100"}
                                            minDate={dayjs().subtract(20, 'year')}
                                            maxDate={dayjs().add(1, 'year')}
                                            format="DD-MM-YYYY"
                                        />
                                    </LocalizationProvider>
                                    {formikSchoolTest.errors.sst_test_date && formikSchoolTest.touched.sst_test_date && <span className="error">{formikSchoolTest.errors.sst_test_date}</span>}
                                </Col>

                                {/* --------------Score / Percentage--------------- */}
                                <Col lg="3" md="3" sm="6" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Score</h6>
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. 80/100"
                                        value={formikSchoolTest.values.sst_score}
                                        onChange={(e) => {
                                            formikSchoolTest.handleChange(e);
                                            formikSchoolTest.setFieldValue('sst_score_percentage', computeScorePercentage(e.target.value));
                                        }}
                                        onBlur={formikSchoolTest.handleBlur}
                                        id="sst_score"
                                        name="sst_score"
                                        className={formikSchoolTest.errors.sst_score && formikSchoolTest.touched.sst_score ? "input-error" : ""}
                                    />
                                    {formikSchoolTest.errors.sst_score && formikSchoolTest.touched.sst_score && <span className="error">{formikSchoolTest.errors.sst_score}</span>}
                                </Col>

                                <Col lg="3" md="3" sm="6" className='position-relative mb-3'>
                                    <h6 className="form-lable">Score %</h6>
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        disabled
                                        placeholder="auto"
                                        value={formikSchoolTest.values.sst_score_percentage !== '' && formikSchoolTest.values.sst_score_percentage != null ? `${parseFloat(formikSchoolTest.values.sst_score_percentage)}%` : ''}
                                        id="sst_score_percentage"
                                        name="sst_score_percentage"
                                    />
                                </Col>

                                {/* --------------Year Level--------------- */}
                                <Col lg="3" md="3" sm="6" className='position-relative mb-3'>
                                    <h6 className="form-lable">Year Level</h6>
                                    <Select menuPlacement="auto" options={yearLevelOptions}
                                        name="sst_year_level"
                                        value={yearLevelOptions.find(option => option.value && formikSchoolTest.values.sst_year_level && option.value.toString() === formikSchoolTest.values.sst_year_level.toString()) || null}
                                        id="sst_year_level"
                                        onChange={(selectedOption) => {
                                            formikSchoolTest.setFieldValue('sst_year_level', selectedOption ? selectedOption.value : '');
                                        }}
                                        onBlur={() => formikSchoolTest.setFieldTouched('sst_year_level', true)}
                                        isClearable
                                    />
                                </Col>

                                {/* --------------Term--------------- */}
                                <Col lg="3" md="3" sm="6" className='position-relative mb-3'>
                                    <h6 className="form-lable">Term</h6>
                                    <Form.Control
                                        type="text"
                                        value={formikSchoolTest.values.sst_term}
                                        onChange={formikSchoolTest.handleChange}
                                        onBlur={formikSchoolTest.handleBlur}
                                        id="sst_term"
                                        name="sst_term"
                                    />
                                </Col>

                                {/* --------------Comment--------------- */}
                                <Col lg="12" md="12" sm="12" className='position-relative'>
                                    <h6 className="form-lable">Comment</h6>
                                    <Form.Control as="textarea" rows={3}
                                        value={formikSchoolTest.values.sst_comment}
                                        onChange={formikSchoolTest.handleChange}
                                        onBlur={formikSchoolTest.handleBlur}
                                        id="sst_comment"
                                        name="sst_comment"
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <div className="mx-auto d-flex gap-2">
                                <Button variant="contained" className="primary-gray" onClick={() => { setModalSchoolTestShow(false); setEditingSchoolTestKey(null); }}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={isSchoolTestSubmitting}>Save</Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* --------------Add / Edit Goal Modal--------------- */}
                <Modal
                    show={modalGoalShow}
                    onHide={() => { setModalGoalShow(false); setEditingGoalKey(null); }}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form autoComplete="off" onSubmit={formikGoal.handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h5 className='page-title'>{editingGoalKey ? 'Edit Goal' : 'Add Goal'}</h5>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Row>
                                {/* --------------Goal--------------- */}
                                <Col lg="12" md="12" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable required-field">Goal</h6>
                                    <Form.Control as="textarea" rows={2}
                                        value={formikGoal.values.sg_title}
                                        onChange={formikGoal.handleChange}
                                        onBlur={formikGoal.handleBlur}
                                        id="sg_title"
                                        name="sg_title"
                                        className={formikGoal.errors.sg_title && formikGoal.touched.sg_title ? "input-error" : ""}
                                    />
                                    {formikGoal.errors.sg_title && formikGoal.touched.sg_title && <span className="error">{formikGoal.errors.sg_title}</span>}
                                </Col>

                                {/* --------------Subject--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable">Subject</h6>
                                    <Form.Control
                                        type="text"
                                        value={formikGoal.values.sg_subject}
                                        onChange={formikGoal.handleChange}
                                        onBlur={formikGoal.handleBlur}
                                        id="sg_subject"
                                        name="sg_subject"
                                    />
                                </Col>

                                {/* --------------Status--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable">Status</h6>
                                    <Select menuPlacement="auto" options={goalStatusOptions}
                                        name="sg_status"
                                        value={goalStatusOptions.find(option => option.value === formikGoal.values.sg_status) || null}
                                        id="sg_status"
                                        onChange={(selectedOption) => {
                                            formikGoal.setFieldValue('sg_status', selectedOption ? selectedOption.value : '');
                                        }}
                                        onBlur={() => formikGoal.setFieldTouched('sg_status', true)}
                                        isClearable
                                    />
                                </Col>

                                {/* --------------Target Date--------------- */}
                                <Col lg="6" md="6" sm="12" className='position-relative mb-3'>
                                    <h6 className="form-lable">Target Date</h6>
                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker views={['year', 'month', 'day']}
                                            value={formikGoal.values.sg_target_date ? dayjs(formikGoal.values.sg_target_date, 'YYYY-MM-DD') : null}
                                            onChange={(date) => {
                                                const event = {
                                                    target: {
                                                        name: "sg_target_date",
                                                        value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : "",
                                                    },
                                                };
                                                formikGoal.handleChange(event);
                                            }}
                                            name="sg_target_date"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small', id: 'sg_target_date' },
                                            }}
                                            className="w-100"
                                            minDate={dayjs().subtract(5, 'year')}
                                            maxDate={dayjs().add(10, 'year')}
                                            format="DD-MM-YYYY"
                                        />
                                    </LocalizationProvider>
                                </Col>

                                {/* --------------Progress Notes--------------- */}
                                <Col lg="12" md="12" sm="12" className='position-relative'>
                                    <h6 className="form-lable">Progress Notes</h6>
                                    <Form.Control as="textarea" rows={3}
                                        value={formikGoal.values.sg_progress_notes}
                                        onChange={formikGoal.handleChange}
                                        onBlur={formikGoal.handleBlur}
                                        id="sg_progress_notes"
                                        name="sg_progress_notes"
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <div className="mx-auto d-flex gap-2">
                                <Button variant="contained" className="primary-gray" onClick={() => { setModalGoalShow(false); setEditingGoalKey(null); }}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={isGoalSubmitting}>Save</Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <Modal show={showModal1} onHide={toggleModal1} size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Parents / Guardians Details</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={formik1.handleSubmit}>
                        <Modal.Body>

                        <Stack className='mt-4' >
                        <div className="my-card p-4 bg-white">
                            <div className='section-heading border-bottom pb-3 mb-3 row'>
                                <Col lg="8" md="8" sm="12" className='position-relative'>
                                    <h6 className='mb-0'>Parents / Guardians Details </h6></Col>

                                <Col lg="4" md="4" sm="12" className='position-relative'>
                                    {/* <h6 className="form-lable required-field">Parent Name</h6> */}
                                    <Select menuPlacement="auto" options={Options_parent}
                                        name="ex_par_key"
                                        value={Options_parent.find(option => option.value && formik1.values.ex_par_key && option.value.toString() === formik1.values.ex_par_key.toString())}
                                        id="ex_par_key"
                                        //  onChange={(selectedOption) => {
                                        //      const event = {
                                        //          target: {
                                        //              name: "ex_par_key",
                                        //              value: selectedOption["value"],
                                        //          },
                                        //      };
                                        //      handleChange(event);
                                        //  }}
                                        onChange={async (selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: "ex_par_key",
                                                    value: selectedOption["value"],
                                                },
                                            };
                                            formik1.handleChange(event);

                                            // Fetch data based on the selected country
                                            try {

                                                const response = await axios.post(BASE_URL + 'API/api_index.php', {
                                                    security_key: security_key,
                                                    mode: "getSingleParentbyCenter",
                                                    pk_par_key: selectedOption["value"]
                                                });

                                                if (response.data.success === true) {
                                                    if (response.data.data.length > 0) {

                                                        formik1.handleChange({ target: { name: 'ps_relationship', value: response.data.data[0].ps_relationship } });
                                                        formik1.handleChange({ target: { name: 'par_firstname', value: response.data.data[0].par_firstname } });
                                                        formik1.handleChange({ target: { name: 'par_surname', value: response.data.data[0].par_surname } });
                                                        formik1.handleChange({ target: { name: 'par_emailid', value: response.data.data[0].par_emailid } });
                                                        formik1.handleChange({ target: { name: 'par_phone', value: response.data.data[0].par_phone } });
                                                        formik1.handleChange({ target: { name: 'par_address', value: response.data.data[0].par_address } });
                                                        formik1.handleChange({ target: { name: 'par_city', value: response.data.data[0].par_city } });
                                                        formik1.handleChange({ target: { name: 'par_country', value: response.data.data[0].par_country } });
                                                        formik1.handleChange({ target: { name: 'par_state', value: response.data.data[0].par_state } });
                                                        formik1.handleChange({ target: { name: 'par_zip', value: response.data.data[0].par_zip } });

                                                    } else {

                                                        formik1.handleChange({ target: { name: 'ps_relationship', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_firstname', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_surname', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_emailid', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_phone', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_address', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_city', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_country', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_state', value: '' } });
                                                        formik1.handleChange({ target: { name: 'par_zip', value: '' } });
                                                    }

                                                } else {
                                                    //console.log("Error fetching abbreviation data");
                                                }

                                                // Update the "yl_abbreviation" field in the Formik values

                                            } catch (error) {
                                                // Handle any errors that occur during the API call
                                                console.error("Error fetching abbreviation data:", error);
                                            }
                                        }}
                                        onBlur={(event) => {
                                            formik1.handleBlur(event);
                                            formik1.setTouched({ ...formik1.touched, ex_par_key: true });
                                        }}
                                        className={formik1.errors.ex_par_key && formik1.touched.ex_par_key ? "input-error" : "mb-0"}
                                    />
                                    {formik1.errors.ex_par_key && formik1.touched.ex_par_key && <p className="error">{formik1.errors.ex_par_key}</p>}
                                </Col>

                            </div>

                            <Row>



                                {/* --------------Student Parents / Guardians --------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Relationship</h6>
                                    <Form.Control type="text"
                                        value={formik1.values.ps_relationship}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="ps_relationship"
                                        className={formik1.errors.ps_relationship && formik1.touched.ps_relationship ? "input-error" : ""}
                                    />
                                    {formik1.errors.ps_relationship && formik1.touched.ps_relationship && <p className="error">{formik1.errors.ps_relationship}</p>}
                                </Col>


                                {/* --------------Contact First Name--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">First Name</h6>
                                    <Form.Control type="text"
                                        value={formik1.values.par_firstname}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="par_firstname"
                                        className={formik1.errors.par_firstname && formik1.touched.par_firstname ? "input-error" : ""} />
                                    {formik1.errors.par_firstname && formik1.touched.par_firstname && <p className="error">{formik1.errors.par_firstname}</p>}
                                </Col>

                                {/* --------------Contact SurName--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Last Name</h6>
                                    <Form.Control type="text"
                                        value={formik1.values.par_surname}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="par_surname"
                                        className={formik1.errors.par_surname && formik1.touched.par_surname ? "input-error" : ""} />
                                    {formik1.errors.par_surname && formik1.touched.par_surname && <p className="error">{formik1.errors.par_surname}</p>}
                                </Col>

                                {/* --------------Contact Email--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable ">Email <a href={`mailto:userID@example.com`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i class="fa-solid fa-envelope me-2"></i></a></h6>
                                    <Form.Control type="email"
                                        value={formik1.values.par_emailid}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="par_emailid"
                                        className={formik1.errors.par_emailid && formik1.touched.par_emailid ? "input-error" : "mb-0"}
                                    />
                                    {formik1.errors.par_emailid && formik1.touched.par_emailid && <p className="error">{formik1.errors.par_emailid}</p>}
                                </Col>

                                {/* --------------Student phone--------------- */}
                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable ">Contact Number <a href='https://web.whatsapp.com/' target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i className="fa-brands fa-whatsapp me-2"></i></a></h6>
                                    {/* <Form.Control type="number"
                                     value={values.par_phone}
                                     onChange={handleChange}
                                     onBlur={handleBlur}
                                     id="par_phone"
                                     className={errors.par_phone && touched.par_phone ? "input-error" : ""}
                                      /> */}
                                    <PhoneInput
                                        {...phoneInputProps()}
                                        name="par_phone"
                                        value={formik1.values.par_phone}
                                        onChange={phoneOnChange(formik1.values, formik1.setValues, 'par_phone', 'par_countryCode')}
                                        onBlur={(event) => {
                                            formik1.handleBlur(event);
                                            formik1.setTouched({ ...formik1.touched, par_phone: true });
                                        }}
                                        inputProps={{id: 'par_phone'}}
                                        id="par_phone"
                                        inputClass={formik1.errors.par_phone && formik1.touched.par_phone ? 'input-error form-control' : 'form-control'}
                                    />
                                    {formik1.errors.par_phone && formik1.touched.par_phone && <span className="error">{formik1.errors.par_phone}</span>}
                                </Col>





                            </Row>
                        </div>
                    </Stack>

                    {/* --------------Contact Details End--------------- */}


                    {/* --------------Contact Details--------------- */}

                    <Stack className='mt-4' style={{ display: formik1.values.ex_par_key != '0' ? 'none' : 'block' }} >
                        <div className="my-card p-4 bg-white">
                            <div className='section-heading border-bottom pb-3 mb-3'>
                                <h6 className='mb-0'>Parent App Login</h6>
                            </div>

                            <Row>
                                {/* --------------Student Username--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Username</h6>
                                    <Form.Control type="text"
                                        value={formik1.values.pa_login_id}
                                        autoComplete="off"

                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="pa_login_id"
                                       // onBlur={handleUsernameBlur1}
                                        className={formik1.errors.pa_login_id && formik1.touched.pa_login_id ? "input-error" : "mb-0"}
                                    />
                                    {formik1.errors.pa_login_id && formik1.touched.pa_login_id && <p className="error">{formik1.errors.pa_login_id}</p>}
                                </Col>

                                {/* --------------Student Password--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Password</h6>
                                    <Form.Control type="password"
                                        autoComplete="new-password"

                                        value={formik1.values.pa_password}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="pa_password"
                                        className={formik1.errors.pa_password && formik1.touched.pa_password ? "input-error" : "mb-0"}
                                    />
                                    {formik1.errors.pa_password && formik1.touched.pa_password && <p className="error">{formik1.errors.pa_password}</p>}
                                </Col>


                                {/* --------------Student Confirm Password--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Confirm Password</h6>
                                    <Form.Control type="password"
                                        autoComplete="new-password"

                                        value={formik1.values.pa_conform_password}
                                        onChange={formik1.handleChange}
                                        onBlur={formik1.handleBlur}
                                        id="pa_conform_password"
                                        className={formik1.errors.pa_conform_password && formik1.touched.pa_conform_password ? "input-error" : "mb-0"} />
                                    {formik1.errors.pa_conform_password && formik1.touched.pa_conform_password && <p className="error">{formik1.errors.pa_conform_password}</p>}
                                </Col>





                            </Row>
                        </div>
                    </Stack>



                        </Modal.Body>
                        <Modal.Footer>

                            <div className="mx-auto d-flex gap-2" >

                                <Button variant="contained" className="primary-gray" onClick={toggleModal1}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={IsSubmittingParent}>Submit</Button>

                            </div>

                        </Modal.Footer>
                    </Form>
                </Modal>

                <Modal show={showModalEditPar} onHide={toggleModalEditPar} size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Additional Parents / Guardians Details</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={formik2.handleSubmit}>
                        <Modal.Body>

                        <Stack className='mt-4' >
                        <div className="my-card p-4 bg-white">
                            <div className='section-heading border-bottom pb-3 mb-3'>
                                <h6 className='mb-0'>Parents / Guardians Details </h6>
                            </div>

                            <Row>

                                {/* --------------Relationship--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Relationship</h6>
                                    <Form.Control type="text"
                                        value={formik2.values.ps_relationship}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        id="ps_relationship"
                                        className={formik2.errors.ps_relationship && formik2.touched.ps_relationship ? "input-error" : ""}
                                    />
                                    {formik2.errors.ps_relationship && formik2.touched.ps_relationship && <p className="error">{formik2.errors.ps_relationship}</p>}
                                </Col>

                                {/* --------------Contact First Name--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">First Name</h6>
                                    <Form.Control type="text"
                                        value={formik2.values.par_firstname}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        id="par_firstname"
                                        className={formik2.errors.par_firstname && formik2.touched.par_firstname ? "input-error" : ""} />
                                    {formik2.errors.par_firstname && formik2.touched.par_firstname && <p className="error">{formik2.errors.par_firstname}</p>}
                                </Col>

                                {/* --------------Contact SurName--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Last Name</h6>
                                    <Form.Control type="text"
                                        value={formik2.values.par_surname}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        id="par_surname"
                                        className={formik2.errors.par_surname && formik2.touched.par_surname ? "input-error" : ""} />
                                    {formik2.errors.par_surname && formik2.touched.par_surname && <p className="error">{formik2.errors.par_surname}</p>}
                                </Col>

                                {/* --------------Contact Email--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable ">Email <a href={`mailto:${formik2.values.par_emailid !== '' ? formik2.values.par_emailid : 'userID@example.com'}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i class="fa-solid fa-envelope me-2"></i></a></h6>
                                    <Form.Control type="email"
                                        value={formik2.values.par_emailid}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        id="par_emailid"
                                        className={formik2.errors.par_emailid && formik2.touched.par_emailid ? "input-error" : "mb-0"}
                                    />
                                    {formik2.errors.par_emailid && formik2.touched.par_emailid && <p className="error">{formik2.errors.par_emailid}</p>}
                                </Col>

                                {/* --------------Contact phone--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable ">Contact Number <a href={`https://wa.me/${formik2.values.par_phone != '' && formik2.values.par_phone != null ? formik2.values.par_phone : ''}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i className="fa-brands fa-whatsapp me-2"></i></a></h6>
                                    <PhoneInput
                                        {...phoneInputProps()}
                                        name="par_phone"
                                        value={formik2.values.par_phone}
                                        onChange={phoneOnChange(formik2.values, formik2.setValues, 'par_phone', 'par_countryCode')}
                                        onBlur={(event) => {
                                            formik2.handleBlur(event);
                                            formik2.setTouched({ ...formik2.touched, par_phone: true });
                                        }}
                                        inputProps={{id: 'par_phone'}}
                                        id="par_phone"
                                        inputClass={formik2.errors.par_phone && formik2.touched.par_phone ? 'input-error form-control' : 'form-control'}
                                    />
                                    {formik2.errors.par_phone && formik2.touched.par_phone && <span className="error">{formik2.errors.par_phone}</span>}
                                </Col>

                            </Row>
                        </div>
                    </Stack>

                        </Modal.Body>
                        <Modal.Footer>

                            <div className="mx-auto d-flex gap-2" >

                                <Button variant="contained" className="primary-gray" onClick={toggleModalEditPar}>Cancel</Button>
                                <Button variant="contained" type='submit' className="primary-filled " disabled={IsSubmittingEditParent}>Submit</Button>

                            </div>

                        </Modal.Footer>
                    </Form>
                </Modal>


                {/* --------------Page Start--------------- */}


                <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className='page-title'> Student Particulars </h5>

                        <div role="presentation">
                            <Breadcrumbs aria-label="breadcrumb" className='my-breadcrumbs'>
                                <NavLink underline="hover" color="inherit" to='/calendar'> Home</NavLink>


                                <Typography color="text.primary">Students</Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                    <div className='d-flex gap-2'>
                        {/*<div>
                            <Button className="secondary-filled " variant="contained" onClick={() => navigate(window.history.back())}>
                                Back
                             </Button>
                         </div>*/}
                        <div className='d-flex justify-content-end gap-2'>
                            <div>
                                <DropdownButton as={ButtonGroup} title="Action" id="dropdown-menu-align-responsive-1" className="ps-0 rounded-10 primary-filled btn-action text-light">
                                    <Dropdown.Item eventKey="1" onClick={handleClick} >  Student Profile
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="2" onClick={handleClick_enroll}> Student Enrolments</Dropdown.Item>
                                    <Dropdown.Item eventKey="4" onClick={handleClick_diagnostics}> Diagnostics Reports</Dropdown.Item>
                                    <Dropdown.Item eventKey="3"><NavLink to='/list-students' > Student List</NavLink></Dropdown.Item>
                                </DropdownButton>
                            </div>
                        </div>
                    </div>

                </div>
                <Row className='g-3'>

                    <Col sm="12" lg="4">
                        {/* --------------Student Details Start--------------- */}

                        {/* Diagnostics link status + management */}
                        <DiagnosticsMappingCard studentKey={Id} />

                        {/* --------------Card-1 Start--------------- */}

                        <Card className='mb-3'>
                            <Card.Body>

                                <div>
                                    <p className='d-flex justify-content-between align-items-center'>
                                        <span>
                                            <ManageAccountsIcon className='me-2 prime-clr' />
                                            <span className='f-16'>
                                                Student Particulars
                                            </span>
                                        </span>
                                        <Button variant="secondary" className="btn-sec-outline" onClick={generateStudentPDF}>
                                            Download PDF
                                        </Button>
                                    </p>
                                </div>

                                <div>

                                    <div className=''>
                                        <p className='mb-2 cus-name'>
                                            {StudentData && StudentData.st_first_name != null ? StudentData.st_first_name + ' ' + StudentData.st_surname : 'N/A'} (#{StudentData ? StudentData.pk_student_id : 0})
                                        </p>
                                    </div>
                                    <div className='d-flex flex-wrap justify-between-content'>
                                        <div className='flex-grow-1'>
                                            <p className='heading-card-cus'>
                                                Age
                                            </p>
                                            <p className='mb-0'>
                                                {StudentAge} years
                                            </p>
                                        </div>

                                        <div className='flex-grow-1'>
                                            <p className='heading-card-cus'>
                                                Year Level
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData ? StudentData.level_name != null && StudentData.level_name != '' ? StudentData.level_name : 'N/A' : 'N/A'}
                                            </p>
                                        </div>

                                        <div className='flex-grow-1'>
                                            <p className='heading-card-cus'>
                                                Date of Birth
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && StudentData.st_dob != '' && StudentData.st_dob != null ? Moment(StudentData.st_dob).format('DD-MM-YYYY') : 'N/A'}
                                            </p>
                                        </div>

                                        {/* <Col lg="12" md="12" sm="12" className='position-relative'>
                                            <h6 className="form-lable required-field">Note</h6>
                                            <Form.Control as="textarea" rows={3}

                                                value={values.sn_note}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                id="sn_note"
                                                className={errors.sn_note && touched.sn_note ? "input-error" : ""}
                                            />
                                            {errors.sn_note && touched.sn_note && <p className="error">{errors.sn_note}</p>}
                                        </Col> */}
                                    </div>

                                </div>

                            </Card.Body>
                        </Card>

                        {/* --------------Card-1 end--------------- */}

                        {/* --------------Card-2 Start--------------- */}

                        <Card className='mb-3'>
                            <Card.Body>


                                <div>
                                    <p>
                                        <ListAltIcon className='me-2 prime-clr' />
                                        <span className='f-16'>
                                            Initial Diagnostics Scores
                                        </span>
                                    </p>
                                </div>

                                <div className='d-flex flex-wrap justify-between-content'>
                                    <div className='flex-grow-1'>

                                        <div className='mb-2'>
                                            <p className='heading-card-cus'>
                                                Reading Age
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && StudentData.la_reading_age != '' && StudentData.la_reading_age != null ? StudentData.la_reading_age : 0} years
                                            </p>
                                        </div>

                                        <div className=''>
                                            <p className='heading-card-cus'>
                                                Spelling Year Level
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && StudentData.lable_spell_year != '' && StudentData.lable_spell_year != null ? StudentData.lable_spell_year : 'N/A'}
                                            </p>
                                        </div>
                                    </div>

                                    <div className='flex-grow-1'>
                                        <div className='mb-2'>
                                            <p className='heading-card-cus'>
                                                Maths Year Level
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && StudentData.lable_maths_year != '' && StudentData.lable_maths_year != null ? StudentData.lable_maths_year : 'N/A'}
                                            </p>
                                        </div>


                                        <div>
                                            <p className='heading-card-cus'>
                                                Comprehension Age
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && StudentData.la_comprehension_age != '' && StudentData.la_comprehension_age != null ? StudentData.la_comprehension_age : 0} Year
                                            </p>
                                        </div>

                                    </div>
                                </div>


                            </Card.Body>
                        </Card>

                        {/* --------------Card-2 end--------------- */}

                        {/* --------------Card-3 Start--------------- */}

                        <Card className='mb-3'>
                            <Card.Body>

                                <div>

                                    <div>
                                        <p>
                                            <CallIcon className='me-2 prime-clr' />
                                            <span className='f-16'>
                                                Parents / Guardians
                                            </span>
                                        </p>
                                    </div>

                                    <div>
                                        <div className="">
                                            <div className="d-flex justify-content-between">
                                                <div className="">
                                                    <p className="mb-0 pb-2">{StudentData && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_firstname != '' && StudentData.par_firstname != null ? StudentData.par_firstname + ' ' + StudentData.par_surname : 'N/A' : 'Adult Learner'} <span className=''>({StudentData ? (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.ps_relationship != '' && StudentData.ps_relationship != null ? StudentData.ps_relationship : 'N/A' : 'No Relationship' : 'N/A'})</span> {StudentData && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_visibility != '' && StudentData.par_visibility != null && parseInt(StudentData.par_visibility)==1 ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Inactive</Badge> : ''} </p>
                                                    <div className='d-flex flex-wrap justify-between-content'>
                                                        <p className="mb-0 me-3 flex-grow-1">
                                                            <a href={`https://wa.me/${StudentData ? StudentData.par_phone != '' && StudentData.par_phone != null && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_phone : '' : ''}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i className="fa-brands fa-whatsapp me-2"></i></a>
                                                            {StudentData ? StudentData.par_phone != '' && StudentData.par_phone != null && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_phone : 'N/A' : ''}
                                                        </p>
                                                        <p className="mb-0 flex-grow-1">
                                                            <a href={`mailto:${StudentData && StudentData.par_emailid != '' && StudentData.par_emailid != null && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_emailid : 'userID@example.com'}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i class="fa-solid fa-envelope me-2"></i></a>

                                                            {StudentData ? StudentData.par_emailid != '' && StudentData.par_emailid != null && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) ? StudentData.par_emailid : 'N/A' : 'N/A'}
                                                        </p>
                                                    </div>
                                                </div>
                                                {/* <p className="menu-icon"><Icon.ThreeDotsVertical onClick={() => (StudentData.st_is_adultlearner!=null && StudentData.st_is_adultlearner==0) && (StudentData.pk_par_key!=null && StudentData.pk_par_key!='') ? toggleModalpass() : ''}/></p> */}

                                                {/* {isDropdownVisible && (
                                                    <div className="Cusdropdown">
                                                    <div>Option 1</div>
                                                    <div>Option 2</div>
                                                    </div>
                                                )} */}
                                                {(StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) && (StudentData.pk_par_key != null && StudentData.pk_par_key != '') && (StudentData.par_visibility != '' && StudentData.par_visibility != null && parseInt(StudentData.par_visibility)==1) ?
                                                     <Dropdown>
                                                     <Dropdown.Toggle as={CustomToggle2} />
                                                     <Dropdown.Menu size="sm" title="">
                                                       <Dropdown.Item onClick={() => toggleModalpass()}>Manage Login</Dropdown.Item>
                                                       {/* <Dropdown.Item>abcd</Dropdown.Item>
                                                       <Dropdown.Item>erty</Dropdown.Item>
                                                       <Dropdown.Item>hnjm</Dropdown.Item> */}
                                                     </Dropdown.Menu>
                                                   </Dropdown>


                                                    // <div className="three-dot-menu">
                                                    //     <div className="three-dot-icon" onClick={toggleDropdown}>
                                                    //         <i className="fas fa-ellipsis-v"></i>
                                                    //     </div>
                                                    //     {isDropdownVisible && (
                                                    //         <div className="dropdown-options">
                                                    //             <div className='d-flex' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }} onClick={() => toggleModalpass()}>Manage Login</div>

                                                    //         </div>
                                                    //     )}
                                                    // </div>
                                                    : ''}
                                            </div>
                                        </div>
                                        <span>

                                        </span>
                                    </div>

                                </div>

                            </Card.Body>
                        </Card>

                        <Card className='mb-3'>
                            <Card.Body>

                                <div>

                                    <div>
                                        <p className=' d-flex justify-content-between'>
                                            <span><CallIcon className='me-2 prime-clr' />

                                                <span className='f-16 '>
                                                    Additional Parents / Guardians

                                                </span></span>

                                           <span className='d-flex justify-content-end'> {StudentSecParData && (StudentSecParData.pk_par_key != null && StudentSecParData.pk_par_key != '')  && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) && (StudentSecParData.par_visibility != '' && StudentSecParData.par_visibility != null && parseInt(StudentSecParData.par_visibility)==1)?
                                                    <Button variant="secondary" className="btn-sec-outline" onClick={() => handlePrimaryClick(StudentSecParData.pk_par_key)} >
                                                    Set Primary
                                                </Button>
                                                    :  externalLoading===false && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0) && (parseInt(StudentSecParData.par_visibility)!=0)  ? <Button variant="secondary" onClick={() => toggleModal1()} className="btn-sec-outline" >
                                                    Add
                                                </Button> : null }</span>
                                        </p>
                                    </div>

                                    <div>
                                        <div className="">
                                        {StudentSecParData && (StudentSecParData.pk_par_key != null && StudentSecParData.pk_par_key != '') && (StudentData.st_is_adultlearner != null && StudentData.st_is_adultlearner == 0)  ?
                                            <div className="d-flex justify-content-between">
                                                <div className="">
                                                    <p className="mb-0 pb-2">{StudentSecParData ? StudentSecParData.par_firstname != '' && StudentSecParData.par_firstname != null ? StudentSecParData.par_firstname + ' ' + StudentSecParData.par_surname : 'Adult Learner' : 'N/A'} <span className=''>({StudentSecParData ?  StudentSecParData.ps_relationship != '' && StudentSecParData.ps_relationship != null ? StudentSecParData.ps_relationship : 'No Relationship' :  'N/A'})</span>{ StudentSecParData ? StudentSecParData.par_visibility != '' && StudentSecParData.par_visibility != null && parseInt(StudentSecParData.par_visibility)==1 ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Inactive</Badge> : ''}</p>
                                                    <div className='d-flex flex-wrap justify-between-content'>
                                                        <p className="mb-0 me-3 flex-grow-1">
                                                            <a href={`https://wa.me/${StudentSecParData ? StudentSecParData.par_phone != '' && StudentSecParData.par_phone != null ? StudentSecParData.par_phone : '' : ''}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i className="fa-brands fa-whatsapp me-2"></i></a>
                                                            {StudentSecParData ? StudentSecParData.par_phone != '' && StudentSecParData.par_phone != null ? StudentSecParData.par_phone : 'N/A' : ''}
                                                        </p>
                                                        <p className="mb-0 flex-grow-1">
                                                            <a href={`mailto:${StudentSecParData && StudentSecParData.par_emailid != '' && StudentSecParData.par_emailid != null ? StudentSecParData.par_emailid : 'userID@example.com'}`} target="_blank" style={{ color: 'black', textDecoration: 'none', }}><i class="fa-solid fa-envelope me-2"></i></a>

                                                            {StudentSecParData ? StudentSecParData.par_emailid != '' && StudentSecParData.par_emailid != null ? StudentSecParData.par_emailid : 'N/A' : 'N/A'}
                                                        </p>
                                                    </div>
                                                </div>
                                                {/* <p className="menu-icon"><Icon.ThreeDotsVertical onClick={() => (StudentData.st_is_adultlearner!=null && StudentData.st_is_adultlearner==0) && (StudentData.pk_par_key!=null && StudentData.pk_par_key!='') ? toggleModalpass() : ''}/></p> */}

                                                {/* {isDropdownVisible && (
                                                    <div className="Cusdropdown">
                                                    <div>Option 1</div>
                                                    <div>Option 2</div>
                                                    </div>
                                                )} */}
                                                {(StudentSecParData.par_firstname != '' && StudentSecParData.par_firstname != null) && (StudentSecParData.pk_par_key != null && StudentSecParData.pk_par_key != '') && (StudentSecParData.par_visibility != null && StudentSecParData.par_visibility != '' && parseInt(StudentSecParData.par_visibility)==1)?
                                                    <Dropdown>
                                                    <Dropdown.Toggle as={CustomToggle} />
                                                    <Dropdown.Menu size="sm" title="">
                                                      <Dropdown.Item onClick={() => toggleModalEditPar()}>Edit</Dropdown.Item>
                                                      <Dropdown.Item onClick={() => toggleModalpass2()}>Manage Login</Dropdown.Item>
                                                      <Dropdown.Item onClick={() => handleDeleteClick(StudentSecParData.pk_par_key)}>Remove</Dropdown.Item>
                                                      {/* <Dropdown.Item>abcd</Dropdown.Item>
                                                      <Dropdown.Item>erty</Dropdown.Item>
                                                      <Dropdown.Item>hnjm</Dropdown.Item> */}
                                                    </Dropdown.Menu>
                                                  </Dropdown>
                                                    // <div className="three-dot-menu">
                                                    //     <div className="three-dot-icon" onClick={toggleDropdown1}>
                                                    //         <i className="fas fa-ellipsis-v"></i>
                                                    //     </div>
                                                    //     {isDropdownVisible1 && (
                                                    //         <div className="dropdown-options">
                                                    //             <div className='d-flex' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }} onClick={() => toggleModalpass2()}>Manage Login</div>

                                                    //         </div>
                                                    //     )}
                                                    // </div>
                                                    : ''}
                                            </div>
                                             : <p>No Additional Parents / Guardians Details</p>}


                                        </div>


                                        <span>

                                        </span>
                                    </div>

                                </div>

                            </Card.Body>
                        </Card>


                        {/* --------------Card-4 Start--------------- */}

                        <Card className='mb-3'>
                            <Card.Body>

                                <div>

                                    <div>
                                        <p>
                                            <AccountBalanceIcon className='me-2 prime-clr' />
                                            <span className='f-16'>
                                                Accounts
                                            </span>
                                        </p>
                                    </div>

                                    <Table responsive className="mb-0">

                                        <thead>
                                            <tr>
                                                <th className='p-0'>Credit ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})</th>
                                                <th className='p-0'>Owing ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})</th>
                                                <th className='p-0'>Paid ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})</th>
                                                <th className='p-0' style={{display:'none'}}>Lessons In Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody className='border-0-cus'>
                                            <tr>
                                            <td className='p-0'>
                                            {StudentData && (parseFloat(StudentData.stu_paid_amount || 0) + parseFloat(StudentData.stu_owing_amount || 0)).toFixed(2)}
                                            </td>
                                            <td className='p-0'>
                                            {StudentData && parseFloat(StudentData.stu_owing_amount || 0).toFixed(2)}
                                            </td>
                                            <td className='p-0'>
                                            {StudentData && parseFloat(StudentData.stu_paid_amount || 0).toFixed(2)}
                                            </td>

                                                {/* <td className='p-0'>{TotalAmountPaid > 0 || PendingAmount > 0 ? (parseFloat(TotalAmountPaid)+parseFloat(PendingAmount)) : 0.00}</td>
                                                <td className='p-0'>{PendingAmount > 0 ? parseFloat(PendingAmount) : 0.00 }</td>
                                                <td className='p-0'>{TotalAmountPaid > 0 ? parseFloat(TotalAmountPaid) : 0.00}</td> */}
                                                <td className='p-0' style={{display:'none'}}><Badge bg="success">Active</Badge></td>
                                            </tr>
                                        </tbody>
                                    </Table>

                                </div>

                            </Card.Body>
                        </Card>

                         <Card className='mb-3'>
                            <Card.Body>


                                <div>
                                    <p>
                                        <AccountBalanceIcon className='me-2 prime-clr' />
                                        <span className='f-16'>
                                            Deposit
                                        </span>
                                    </p>
                                </div>

                                <div className='d-flex flex-wrap justify-between-content'>
                                    <div className='flex-grow-1'>

                                        {/* <div className='mb-2'>
                                            <p className='heading-card-cus-black' >
                                                Credit ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && (parseFloat(StudentData.deposit_paid_amount || 0) + parseFloat(StudentData.deposit_unpaid_amount || 0)).toFixed(2)}
                                            </p>
                                        </div> */}


                                        <div className='mb-2'>
                                            <p className='heading-card-cus-black' >
                                               Deposit ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && parseFloat(StudentData.deposit_paid_amount || 0).toFixed(2)}
                                            </p>
                                        </div>
                                        <div>
                                            <p className='heading-card-cus-black' >
                                               Deposit Balance ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && parseFloat(StudentData.deposit_balence_amount || 0).toFixed(2)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className='flex-grow-1'>
                                        {/* <div className='mb-2'>
                                            <p className='heading-card-cus-black'>
                                                Owing ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                               {StudentData && parseFloat(StudentData.deposit_unpaid_amount || 0).toFixed(2)}
                                            </p>
                                        </div> */}
                                        <div className='mb-2'>
                                            <p className='heading-card-cus-black' >
                                              Deposit used for session ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                                {StudentData && (() => {
                                                const paid = parseFloat(StudentData.deposit_paid_amount || 0);
                                                const balance = parseFloat(StudentData.deposit_balence_amount || 0);
                                                const refunded = parseFloat(StudentData.deposit_refund_amount || 0);
                                                return (paid - balance - refunded).toFixed(2);
                                                })()}

                                            </p>
                                        </div>
                                        <div className='mb-2'>
                                            <p className='heading-card-cus-black'>
                                                Deposit Refund ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})
                                            </p>
                                            <p className='mb-0'>
                                               {StudentData && parseFloat(StudentData.deposit_refund_amount || 0).toFixed(2)}
                                            </p>
                                        </div>
                                    </div>
                                </div>


                            </Card.Body>
                        </Card>

                        {/* --------------Card-4 end--------------- */}

                        <Card className=''>
                            <Card.Body>

                                <div>

                                    <div>
                                        <p>
                                            <AccountBalanceWalletIcon className='me-2 prime-clr' />
                                            <span className='f-16'>
                                                {/* Payment Frequency */}
                                                Wallet
                                            </span>
                                        </p>
                                    </div>

                                    <Table responsive className="mb-0">

                                        <thead>
                                            <tr>
                                                <th className='p-0'>Available Wallet Balance ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})</th>
                                                <th className='p-0'>Total Wallet Utilized ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'})</th>
                                            </tr>
                                        </thead>
                                        <tbody className='border-0-cus'>
                                            <tr>
                                                {console.log(sumByType(wallet_data, 1))}
                                                {console.log(sumByType(wallet_data, 2))}
                                                <td className='p-0'>{(sumByType(wallet_data, 1) - sumByType(wallet_data, 2)).toFixed(2)}</td>
                                                <td className='p-0'>{sumByType(wallet_data, 2).toFixed(2)}</td>
                                                {/* <td className='p-0'><Badge bg="success">Active</Badge></td> */}
                                            </tr>
                                        </tbody>
                                    </Table>

                                </div>

                            </Card.Body>
                        </Card>

                        {/* --------------Student Details End--------------- */}
                    </Col>



                    <Col sm="12" lg="8">
                        {/* --------------Tabs Section-2 Start--------------- */}

                        <Card className='my-card mb-3 h-100'>

                            <Card.Body>

                                {/* --------------Tabs Section-1 Start--------------- */}

                                <div className="">

                                    <Tab.Container defaultActiveKey="first">

                                        <Nav variant="pills" className="flex-row rounded-2 text-dark">
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="first" className="d-flex rounded-2 px-2">
                                                    <i class="fa-solid fa-book-open me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">Lessons </p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="second" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-bullseye me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">Goals</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="third" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-note-sticky me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">Notes</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="four" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-book-reader me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">myGooRoo Points</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="five" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-book-open me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">School Test Details</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="six" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-note-sticky me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">Payment Notes</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="seven" className="d-flex rounded-2 px-3">
                                                    {/* <i class="fa-solid fa-note-sticky me-md-2 my-auto"></i> */}
                                                    <AccountBalanceWalletIcon className='me-md-2 my-auto' style={{fontSize: "18PX"}} />
                                                    <p className="mb-0 d-none d-md-block">Wallet</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="">
                                                <Nav.Link eventKey="eight" className="d-flex rounded-2 px-3">
                                                    <i class="fa-solid fa-pause-circle me-md-2 my-auto"></i>
                                                    <p className="mb-0 d-none d-md-block">Pauses</p>
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        {/* --------------Toggle Selector End--------------- */}

                                        {/* --------------Toggle Content Start--------------- */}

                                        <Tab.Content className='mt-3'>
                                            {/* --------------Toggle One Start--------------- */}
                                            <Tab.Pane eventKey="first" className="">

                                                <Stack gap={3} >
                                                    <div className="mb-3">

                                                        <div className="cus-les-sec">

                                                            <div className='cus-les-left'>
                                                                <div className="cus-les-sd">
                                                                    <Form>

                                                                        {/* --------------Start Date--------------- */}
                                                                        <Form.Group className="form-group d-flex align-items-center" controlId="formsdate">
                                                                            <Form.Label className="pe-2 mb-0">
                                                                                <p className="mb-0">Start Date</p>
                                                                            </Form.Label>
                                                                            <Col className="">
                                                                                {/* <input type="date" className="form-control mb-0" onChange={handleStartDateChange} value={startDate} /> */}
                                                                                <LocalizationProvider className={'form-control mb-0'} dateAdapter={AdapterDayjs}>
                                                                                        <DatePicker  views={['year', 'month', 'day']}
                                                                                            value={dayjs(startDate, 'YYYY-MM-DD')}
                                                                                            onChange={handleStartDateChange}
                                                                                            // minDate={dayjs()}
                                                                                            format="DD-MM-YYYY"
 />
                                                                                    </LocalizationProvider>
                                                                            </Col>
                                                                        </Form.Group>

                                                                    </Form>
                                                                </div>

                                                                <div className="cus-les-ed">
                                                                    <Form>

                                                                        {/* --------------End Date--------------- */}
                                                                        <Form.Group className="form-group d-flex align-items-center" controlId="formedate">
                                                                            <Form.Label className="pe-2 mb-0">
                                                                                <p className="mb-0">End Date</p>
                                                                            </Form.Label>
                                                                            <Col className="">
                                                                                {/* <input type="date" className="form-control mb-0" onChange={handleEndDateChange} value={endDate} /> */}
                                                                                <LocalizationProvider className={'form-control mb-0'} dateAdapter={AdapterDayjs}>
                                                                                    <DatePicker  views={['year', 'month', 'day']}
                                                                                        value={dayjs(endDate, 'YYYY-MM-DD')}
                                                                                        onChange={handleEndDateChange}
                                                                                        minDate={dayjs(startDate, 'YYYY-MM-DD')}
                                                                                        format="DD-MM-YYYY"
                                                                                        />
                                                                                </LocalizationProvider>
                                                                            </Col>
                                                                        </Form.Group>

                                                                    </Form>
                                                                </div>
                                                            </div>

                                                            <div className='cus-les-right'>


                                                                <div className="cus-les-rst">
                                                                    <Button variant="secondary" className="btn-sec-outline" onClick={handleDateReset}>
                                                                        Reset
                                                                    </Button>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </Stack>

                                                {/* <DataTableExtensions {...tableData}> */}

                                                <Row>
                                                    <Col sm={12}>
                                                        <Box
                                                            sx={{
                                                                height: "fit-content",
                                                                width: "100%",
                                                                "& .actions": {
                                                                    color: "text.secondary",
                                                                },
                                                                "& .textPrimary": {
                                                                    color: "text.primary",
                                                                },
                                                                "& .super-app-theme--header": {
                                                                    backgroundColor: "#f4f4f4",
                                                                },
                                                            }}
                                                            style={{ height: '100%', width: "100%" }}
                                                        >
                                                           <DataGrid
  sx={{
                                  // disable cell selection style
                                  '.MuiDataGrid-cell:focus': {
                                    outline: 'none'
                                  },
                                  // pointer cursor on ALL rows
                                  '& .MuiDataGrid-row:hover': {
                                    cursor: 'pointer'
                                  }
                                }}
                                                                //sx={{ border: "none", m: 2 }}
                                                                autoHeight
                                                                slots={{
                                                                    loadingOverlay: LinearProgress,
                                                                    //noRowsOverlay: CustomNoRowsOverlay,
                                                                    toolbar: GridToolbar,
                                                                    // toolbar: EditToolbar,
                                                                }}
                                                                slotProps={{
                                                                    toolbar: {
                                                                        csvOptions: { fileName: "LessonList" },
                                                                        printOptions: { pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "LessonList" },
                                                                        lessonRecords,
                                                                        showQuickFilter: true
                                                                    },


                                                                }}
                                                                initialState={{
                                                                    ...lessonRecords.initialState,
                                                                    pagination: { paginationModel: { pageSize: 10 } },
                                                                }}
                                                                showQuickFilter={true}

                                                                pageSizeOptions={[10, 25, 50, 100]}

                                                                loading={loading}
                                                                rows={lessonRecords.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                                columns={columnsLesson}
                                                                rowHeight={60} density="compact"
disableRowSelectionOnClick
showCellVerticalBorder= {true}
showColumnVerticalBorder= {true}
                                                                onRowClick={(params) => handleLessonViewClick(params.row)}


                                                            />


                                                        </Box>


                                                    </Col>
                                                </Row>

                                                {/* </DataTableExtensions> */}
                                            </Tab.Pane>
                                            {/* --------------Toggle One End--------------- */}

                                            {/* --------------Toggle Second Start--------------- */}
                                            <Tab.Pane eventKey="second">
                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            <Col md={12} lg={12} className="d-flex justify-content-end align-self-center">
                                                                <Button variant="primary" className="me-2" size="sm" onClick={handleAddGoal}>
                                                                    Add Goal
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": { color: "text.secondary" },
                                                        "& .textPrimary": { color: "text.primary" },
                                                        "& .super-app-theme--header": { backgroundColor: "#f4f4f4" },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                    <DataGrid
                                                        sx={{
                                                            '.MuiDataGrid-cell:focus': { outline: 'none' },
                                                            '& .MuiDataGrid-row:hover': { cursor: 'pointer' }
                                                        }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            toolbar: GridToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "GoalsList" },
                                                                printOptions: { disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "GoalsList" },
                                                                goalData,
                                                                showQuickFilter: true
                                                            },
                                                        }}
                                                        initialState={{
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}
                                                        pageSizeOptions={[10, 25, 50, 100]}
                                                        loading={loading}
                                                        rows={goalData.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_goals}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder={true}
                                                        showColumnVerticalBorder={true}
                                                    />
                                                </Box>
                                            </Tab.Pane>
                                            {/* --------------Toggle Second End--------------- */}

                                            {/* --------------Toggle Third Start--------------- */}
                                            <Tab.Pane eventKey="third">

                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>

                                                            <Col md={12} lg={8}>
                                                                {/*
                                                            <Row>
                                                                <Col xs={12} md={6} lg={6}>
                                                                    <Form>


                                                                        <Form.Group className="d-flex align-items-center" controlId="formsdate">
                                                                            <Form.Label className="my-auto me-2">
                                                                                <p className="mb-0">Start Date</p>
                                                                            </Form.Label>
                                                                            <Col className="mx-0">
                                                                                <input type="date" className="form-control mb-0" />
                                                                            </Col>
                                                                        </Form.Group>

                                                                    </Form>
                                                                </Col>

                                                                <Col xs={12} md={6} lg={6}>
                                                                    <Form>


                                                                        <Form.Group className="d-flex align-items-center" controlId="formedate">
                                                                            <Form.Label className="my-auto me-2">
                                                                                <p className="mb-0">End Date</p>
                                                                            </Form.Label>
                                                                            <Col className="mx-0">
                                                                                <input type="date" className="form-control mb-0" />
                                                                            </Col>
                                                                        </Form.Group>

                                                                    </Form>
                                                                </Col>
                                                            </Row> */}

                                                            </Col>


                                                            <Col md={12} lg={4} className="d-flex justify-content-end align-self-center">

                                                                <Button variant="primary" className="me-2" size="sm" onClick={() => setModalShow(true)}>
                                                                    Add Notes
                                                                </Button>
                                                                {/* <Button  variant="secondary" className="btn-sec-outline" onClick={toggleModal1}>
                                                                Unenrol
                                                            </Button> */}

                                                            </Col>

                                                        </Row>
                                                    </div>
                                                </Stack>




                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                   <DataGrid
  sx={{
                                  // disable cell selection style
                                  '.MuiDataGrid-cell:focus': {
                                    outline: 'none'
                                  },
                                  // pointer cursor on ALL rows
                                  '& .MuiDataGrid-row:hover': {
                                    cursor: 'pointer'
                                  }
                                }}
                                                        //sx={{ border: "none", m: 2 }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            //noRowsOverlay: CustomNoRowsOverlay,
                                                            toolbar: GridToolbar,
                                                            // toolbar: EditToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "NoteList" },
                                                                printOptions: { pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "NoteList" },
                                                                note_data,
                                                                showQuickFilter: true
                                                            },


                                                        }}
                                                        initialState={{
                                                            ...note_data.initialState,
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}

                                                        pageSizeOptions={[10, 25, 50, 100]}

                                                        loading={loading}
                                                        rows={note_data.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_notes}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder= {true}
                                                        showColumnVerticalBorder= {true}


                                                    />


                                                </Box>

                                                <Stack gap={3} className="mt-4">
                                                    <div className="mb-1">
                                                        <h5 className='page-title'> Tutor Notes </h5>
                                                        <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>
                                                            Notes added by tutors for this student (read-only).
                                                        </p>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                    <DataGrid
                                                        sx={{
                                                            '.MuiDataGrid-cell:focus': {
                                                                outline: 'none'
                                                            },
                                                            '& .MuiDataGrid-row:hover': {
                                                                cursor: 'pointer'
                                                            }
                                                        }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            toolbar: GridToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "TutorNoteList" },
                                                                printOptions: { disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "TutorNoteList" },
                                                                showQuickFilter: true
                                                            },
                                                        }}
                                                        initialState={{
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}
                                                        pageSizeOptions={[10, 25, 50, 100]}
                                                        loading={loading}
                                                        rows={tutor_note_data.map((row, index) => ({ ...row, id: `tutor-row-${index}` }))}
                                                        columns={columns_tutor_notes}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder={true}
                                                        showColumnVerticalBorder={true}
                                                    />
                                                </Box>

                                            </Tab.Pane>
                                            {/* --------------Toggle Third End--------------- */}
                                            {/* --------------Toggle One Start--------------- */}
                                            <Tab.Pane eventKey="four" className="">

                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            <Col md={12} lg={12} className="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <h6 className='mb-0 fw-bold'>Coins</h6>
                                                                    <h6 className='mb-0 mt-2'>
                                                                        Lifetime Coins : <span className='text-success'>{currentStudentCoins}</span>
                                                                    </h6>
                                                                    <h6 className='mb-0 mt-1'>
                                                                        Available Coins : <span className='text-primary'>{currentStudentSpendableCoins}</span>
                                                                    </h6>
                                                                </div>
                                                                <div className="d-flex justify-content-end">
                                                                    <Button
                                                                        variant="success"
                                                                        className="me-2"
                                                                        size="sm"
                                                                        onClick={toggleModalAddCoins}
                                                                    >
                                                                        Add Coins
                                                                    </Button>
                                                                    <Button
                                                                        variant="primary"
                                                                        className="me-2"
                                                                        size="sm"
                                                                        onClick={toggleModalReduceCoins}
                                                                        disabled={currentStudentSpendableCoins <= 0}
                                                                    >
                                                                        Remove Coins
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                    <DataGrid
                                                        sx={{
                                                            '.MuiDataGrid-cell:focus': {
                                                                outline: 'none'
                                                            },
                                                            '& .MuiDataGrid-row:hover': {
                                                                cursor: 'pointer'
                                                            }
                                                        }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            toolbar: GridToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "PointList" },
                                                                printOptions: {
                                                                    pageStyle: `@media print {
                          @page {
                            size: A4 landscape;
                            margin: 0;
                          }
                        }`,
                                                                    disableToolbarButton: true,
                                                                    hideFooter: true,
                                                                    hideToolbar: true,
                                                                    fileName: "PointList"
                                                                },
                                                                CoinRecords,
                                                                showQuickFilter: true
                                                            },
                                                        }}
                                                        initialState={{
                                                            ...CoinRecords.initialState,
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}
                                                        pageSizeOptions={[10, 25, 50, 100]}
                                                        loading={loading}
                                                        rows={CoinRecords.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columnsCoin}
                                                        rowHeight={60}
                                                        density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder={true}
                                                        showColumnVerticalBorder={true}
                                                    />
                                                </Box>

                                                <Stack gap={3} className="mt-4">
                                                    <div className="mb-3">
                                                        <Row>
                                                            <Col md={12} lg={12} className="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <h6 className='mb-0 fw-bold'>Points</h6>
                                                                    <h6 className='mb-0 mt-2'>
                                                                        Lifetime Points : <span className='text-success'>{currentStudentPoints}</span>
                                                                    </h6>
                                                                    <h6 className='mb-0 mt-1'>
                                                                        Available Points : <span className='text-primary'>{currentStudentAvailablePoints}</span>
                                                                    </h6>
                                                                </div>
                                                                <div className="d-flex justify-content-end">
                                                                    <Button
                                                                        variant="success"
                                                                        className="me-2"
                                                                        size="sm"
                                                                        onClick={toggleModalAddPoints}
                                                                    >
                                                                        Add Points
                                                                    </Button>
                                                                    <Button
                                                                        variant="primary"
                                                                        className="me-2"
                                                                        size="sm"
                                                                        onClick={toggleModalReducePoints}
                                                                        disabled={currentStudentAvailablePoints <= 0}
                                                                    >
                                                                        Remove Points
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                    <DataGrid
                                                        sx={{
                                                            '.MuiDataGrid-cell:focus': {
                                                                outline: 'none'
                                                            },
                                                            '& .MuiDataGrid-row:hover': {
                                                                cursor: 'pointer'
                                                            }
                                                        }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            toolbar: GridToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "PointList" },
                                                                printOptions: {
                                                                    pageStyle: `@media print {
                          @page {
                            size: A4 landscape;
                            margin: 0;
                          }
                        }`,
                                                                    disableToolbarButton: true,
                                                                    hideFooter: true,
                                                                    hideToolbar: true,
                                                                    fileName: "PointList"
                                                                },
                                                                PointRecords,
                                                                showQuickFilter: true
                                                            },
                                                        }}
                                                        initialState={{
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}
                                                        pageSizeOptions={[10, 25, 50, 100]}
                                                        loading={loading}
                                                        rows={PointRecords.map((row, index) => ({ ...row, id: `point-row-${index}` }))}
                                                        columns={columnsPoint}
                                                        rowHeight={60}
                                                        density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder={true}
                                                        showColumnVerticalBorder={true}
                                                    />
                                                </Box>

                                            </Tab.Pane>
                                            {/* --------------Toggle One End--------------- */}

                                            {/* --------------Toggle One Start--------------- */}
                                            <Tab.Pane eventKey="five" className="">

                                                {isCentreAdmin &&
                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            <Col md={12} lg={12} className="d-flex justify-content-end align-self-center">

                                                                <Button variant="primary" className="me-2" size="sm" onClick={handleAddSchoolTest}>
                                                                    Add Test Score
                                                                </Button>

                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Stack>
                                                }


                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                   <DataGrid
  sx={{
                                  // disable cell selection style
                                  '.MuiDataGrid-cell:focus': {
                                    outline: 'none'
                                  },
                                  // pointer cursor on ALL rows
                                  '& .MuiDataGrid-row:hover': {
                                    cursor: 'pointer'
                                  }
                                }}
                                                        //sx={{ border: "none", m: 2 }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            //noRowsOverlay: CustomNoRowsOverlay,
                                                            toolbar: GridToolbar,
                                                            // toolbar: EditToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "TestList" },
                                                                printOptions: { pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "TestList" },
                                                                schoolTestData,
                                                                showQuickFilter: true
                                                            },


                                                        }}
                                                        initialState={{
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}

                                                        pageSizeOptions={[10, 25, 50, 100]}

                                                        loading={loading}
                                                        rows={schoolTestData.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_school_test}
                                                        rowHeight={60} density="compact"
disableRowSelectionOnClick
showCellVerticalBorder= {true}
showColumnVerticalBorder= {true}


                                                    />


                                                </Box>




                                            </Tab.Pane>
                                            {/* --------------Toggle One End--------------- */}
                                             {/* --------------Toggle six Start--------------- */}
                                             <Tab.Pane eventKey="six">

                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            {/* <Col md={12} lg={8}>
                                                            </Col> */}
                                                            <Col md={12} lg={12} className="d-flex justify-content-end align-self-center">

                                                                <Button variant="primary" className="me-2" size="sm" onClick={() => setModalPaymentNotesShow(true)}>
                                                                    Add Payment Notes
                                                                </Button>

                                                            </Col>

                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                <DataGrid
                                                sx={{
                                                // disable cell selection style
                                                '.MuiDataGrid-cell:focus': {
                                                outline: 'none'
                                                },
                                                // pointer cursor on ALL rows
                                                '& .MuiDataGrid-row:hover': {
                                                cursor: 'pointer'
                                                }
                                                }}
                                                        //sx={{ border: "none", m: 2 }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            //noRowsOverlay: CustomNoRowsOverlay,
                                                            toolbar: GridToolbar,
                                                            // toolbar: EditToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "PaymentNoteList" },
                                                                printOptions: { pageStyle: `@media print {
                                                                                            @page {
                                                                                            size: A4 landscape;
                                                                                            margin: 0;
                                                                                            }
                                                                                            }`,
                                                                    disableToolbarButton: true,
                                                                    hideFooter: true,
                                                                    hideToolbar: true,
                                                                    fileName: "PaymentNoteList"
                                                                },
                                                                payment_note_data,
                                                                showQuickFilter: true
                                                            },


                                                        }}
                                                        initialState={{
                                                            ...payment_note_data.initialState,
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}

                                                        pageSizeOptions={[10, 25, 50, 100]}

                                                        loading={loading}
                                                        rows={payment_note_data.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_payment_notes}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder= {true}
                                                        showColumnVerticalBorder= {true}


                                                    />


                                                </Box>

                                            </Tab.Pane>
                                            {/* --------------Toggle six End--------------- */}
                                            {/* --------------Toggle seven Start--------------- */}
                                             <Tab.Pane eventKey="seven">

                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            {/* <Col md={12} lg={8}>
                                                            </Col> */}
                                                            <Col md={12} lg={12} className="d-flex justify-content-between align-self-center gap-1">
                                                                <div className="d-flex justify-content-start align-self-center gap-3">
                                                                    <h6 className='align-self-center'>Available Wallet Balance ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'}) :<span className='text-success'> {(sumByType(wallet_data, 1) - sumByType(wallet_data, 2)).toFixed(2)}</span></h6>
                                                                    <h6 className='align-self-center'>Total Wallet Utilized ({sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD'}) : <span className='text-danger'>{sumByType(wallet_data, 2).toFixed(2)}</span></h6>
                                                                </div>
                                                                <div className="d-flex justify-content-end align-self-center">
                                                                    <Button variant="primary" className="me-2" size="sm" onClick={() => handleOpenAddWallet()}>
                                                                    Add to Wallet
                                                                    </Button>
                                                                    {/* {(sumByType(wallet_data, 1) - sumByType(wallet_data, 2)) > 0 ? */}
                                                                    <Button variant="danger" className="me-2" size="sm" onClick={() => {
                                                                        setModelRefundWallet(true);
                                                                        formikRefundWallet.resetForm();
                                                                    }}>
                                                                    Deduct from Wallet
                                                                    </Button> 
                                                                    {/* : null} */}
                                                                </div>

                                                            </Col>

                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": {
                                                            color: "text.secondary",
                                                        },
                                                        "& .textPrimary": {
                                                            color: "text.primary",
                                                        },
                                                        "& .super-app-theme--header": {
                                                            backgroundColor: "#f4f4f4",
                                                        },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                <DataGrid
                                                sx={{
                                                // disable cell selection style
                                                '.MuiDataGrid-cell:focus': {
                                                outline: 'none'
                                                },
                                                // pointer cursor on ALL rows
                                                '& .MuiDataGrid-row:hover': {
                                                cursor: 'pointer'
                                                }
                                                }}
                                                        //sx={{ border: "none", m: 2 }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            //noRowsOverlay: CustomNoRowsOverlay,
                                                            toolbar: GridToolbar,
                                                            // toolbar: EditToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "WalletList" },
                                                                printOptions: { pageStyle: `@media print {
                                                                                            @page {
                                                                                            size: A4 landscape;
                                                                                            margin: 0;
                                                                                            }
                                                                                            }`,
                                                                    disableToolbarButton: true,
                                                                    hideFooter: true,
                                                                    hideToolbar: true,
                                                                    fileName: "WalletList"
                                                                },
                                                                wallet_data,
                                                                showQuickFilter: true
                                                            },


                                                        }}
                                                        initialState={{
                                                            ...wallet_data.initialState,
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}

                                                        pageSizeOptions={[10, 25, 50, 100]}

                                                        loading={loading}
                                                        rows={wallet_data.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_wallet}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder= {true}
                                                        showColumnVerticalBorder= {true}


                                                    />


                                                </Box>

                                            </Tab.Pane>
                                            {/* --------------Toggle seven End--------------- */}
                                            {/* --------------Toggle eight Start--------------- */}
                                            <Tab.Pane eventKey="eight">

                                                <Stack gap={3}>
                                                    <div className="mb-3">
                                                        <Row>
                                                            {/* <Col md={12} lg={12} className="d-flex justify-content-end align-self-center">
                                                                <Button variant="primary" className="me-2" size="sm" onClick={handleAddPause}>
                                                                    Add Pause
                                                                </Button>
                                                            </Col> */}
                                                        </Row>
                                                    </div>
                                                </Stack>

                                                <Box
                                                    sx={{
                                                        height: "fit-content",
                                                        width: "100%",
                                                        "& .actions": { color: "text.secondary" },
                                                        "& .textPrimary": { color: "text.primary" },
                                                        "& .super-app-theme--header": { backgroundColor: "#f4f4f4" },
                                                    }}
                                                    style={{ height: '100%', width: "100%" }}
                                                >
                                                    <DataGrid
                                                        sx={{
                                                            '.MuiDataGrid-cell:focus': { outline: 'none' },
                                                            '& .MuiDataGrid-row:hover': { cursor: 'pointer' }
                                                        }}
                                                        autoHeight
                                                        slots={{
                                                            loadingOverlay: LinearProgress,
                                                            toolbar: GridToolbar,
                                                        }}
                                                        slotProps={{
                                                            toolbar: {
                                                                csvOptions: { fileName: "Paused List" },
                                                                printOptions: { disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "PauseList" },
                                                                pause_data,
                                                                showQuickFilter: true
                                                            },
                                                        }}
                                                        initialState={{
                                                            pagination: { paginationModel: { pageSize: 10 } },
                                                        }}
                                                        showQuickFilter={true}
                                                        pageSizeOptions={[10, 25, 50, 100]}
                                                        loading={loading}
                                                        rows={pause_data.map((row, index) => ({ ...row, id: `row-${index}` }))}
                                                        columns={columns_pause}
                                                        rowHeight={60} density="compact"
                                                        disableRowSelectionOnClick
                                                        showCellVerticalBorder={true}
                                                        showColumnVerticalBorder={true}
                                                    />
                                                </Box>

                                            </Tab.Pane>
                                            {/* --------------Toggle eight end--------------- */}
                                        </Tab.Content>
                                        {/* --------------Toggle Content Start--------------- */}
                                    </Tab.Container>

                                </div>

                                {/* --------------Tabs Section-1 End--------------- */}


                            </Card.Body>

                        </Card>

                        {/* --------------Tabs Section-2 End--------------- */}
                    </Col>
                </Row>



                {/* --------------Page End--------------- */}

            </div>

            <Modal
                show={showModalReduceCoins}
                onHide={toggleModalReduceCoins}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Remove Coins</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikReduceCoins.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col lg="12" md="12" sm="12" className='mb-3'>
                                <h6 className="form-lable">Current Available Coins</h6>
                                <p className="mb-0">{currentStudentSpendableCoins}</p>
                            </Col>

                            <Col lg="6" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="coin_amount"
                                    name="coin_amount"
                                    min="1"
                                    max={currentStudentSpendableCoins}
                                    step="1"
                                    value={formikReduceCoins.values.coin_amount}
                                    onChange={formikReduceCoins.handleChange}
                                    onBlur={formikReduceCoins.handleBlur}
                                    className={
                                        formikReduceCoins.errors.coin_amount &&
                                        formikReduceCoins.touched.coin_amount
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikReduceCoins.errors.coin_amount &&
                                    formikReduceCoins.touched.coin_amount && (
                                        <p className="error">{formikReduceCoins.errors.coin_amount}</p>
                                    )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className='position-relative mt-3'>
                                <h6 className="form-lable required-field">Reason</h6>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    id="remarks"
                                    name="remarks"
                                    value={formikReduceCoins.values.remarks}
                                    onChange={formikReduceCoins.handleChange}
                                    onBlur={formikReduceCoins.handleBlur}
                                    className={
                                        formikReduceCoins.errors.remarks &&
                                        formikReduceCoins.touched.remarks
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikReduceCoins.errors.remarks &&
                                    formikReduceCoins.touched.remarks && (
                                        <p className="error">{formikReduceCoins.errors.remarks}</p>
                                    )}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="mx-auto d-flex gap-2">
                            <Button
                                variant="contained"
                                className="primary-gray"
                                onClick={toggleModalReduceCoins}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                className="primary-filled"
                                disabled={isReduceCoinsSubmitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal
                show={showModalAddCoins}
                onHide={toggleModalAddCoins}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Coins</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikAddCoins.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col lg="6" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="coin_amount"
                                    name="coin_amount"
                                    min="1"
                                    step="1"
                                    value={formikAddCoins.values.coin_amount}
                                    onChange={formikAddCoins.handleChange}
                                    onBlur={formikAddCoins.handleBlur}
                                    className={
                                        formikAddCoins.errors.coin_amount &&
                                        formikAddCoins.touched.coin_amount
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikAddCoins.errors.coin_amount &&
                                    formikAddCoins.touched.coin_amount && (
                                        <p className="error">{formikAddCoins.errors.coin_amount}</p>
                                    )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className='position-relative mt-3'>
                                <h6 className="form-lable required-field">Reason</h6>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    id="remarks"
                                    name="remarks"
                                    value={formikAddCoins.values.remarks}
                                    onChange={formikAddCoins.handleChange}
                                    onBlur={formikAddCoins.handleBlur}
                                    className={
                                        formikAddCoins.errors.remarks &&
                                        formikAddCoins.touched.remarks
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikAddCoins.errors.remarks &&
                                    formikAddCoins.touched.remarks && (
                                        <p className="error">{formikAddCoins.errors.remarks}</p>
                                    )}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="mx-auto d-flex gap-2">
                            <Button
                                variant="contained"
                                className="primary-gray"
                                onClick={toggleModalAddCoins}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                className="primary-filled"
                                disabled={isAddCoinsSubmitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal
                show={showModalAddPoints}
                onHide={toggleModalAddPoints}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Points</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikAddPoints.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col lg="6" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="point_amount"
                                    name="point_amount"
                                    min="1"
                                    step="1"
                                    value={formikAddPoints.values.point_amount}
                                    onChange={formikAddPoints.handleChange}
                                    onBlur={formikAddPoints.handleBlur}
                                    className={
                                        formikAddPoints.errors.point_amount &&
                                        formikAddPoints.touched.point_amount
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikAddPoints.errors.point_amount &&
                                    formikAddPoints.touched.point_amount && (
                                        <p className="error">{formikAddPoints.errors.point_amount}</p>
                                    )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className='position-relative mt-3'>
                                <h6 className="form-lable required-field">Reason</h6>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    id="remarks"
                                    name="remarks"
                                    value={formikAddPoints.values.remarks}
                                    onChange={formikAddPoints.handleChange}
                                    onBlur={formikAddPoints.handleBlur}
                                    className={
                                        formikAddPoints.errors.remarks &&
                                        formikAddPoints.touched.remarks
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikAddPoints.errors.remarks &&
                                    formikAddPoints.touched.remarks && (
                                        <p className="error">{formikAddPoints.errors.remarks}</p>
                                    )}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="mx-auto d-flex gap-2">
                            <Button
                                variant="contained"
                                className="primary-gray"
                                onClick={toggleModalAddPoints}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                className="primary-filled"
                                disabled={isAddPointsSubmitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal
                show={showModalReducePoints}
                onHide={toggleModalReducePoints}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Remove Points</Modal.Title>
                </Modal.Header>
                <Form onSubmit={formikReducePoints.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col lg="12" md="12" sm="12" className='mb-3'>
                                <h6 className="form-lable">Current Available Points</h6>
                                <p className="mb-0">{currentStudentAvailablePoints}</p>
                            </Col>

                            <Col lg="6" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Amount</h6>
                                <Form.Control
                                    type="number"
                                    id="point_amount"
                                    name="point_amount"
                                    min="1"
                                    max={currentStudentAvailablePoints}
                                    step="1"
                                    value={formikReducePoints.values.point_amount}
                                    onChange={formikReducePoints.handleChange}
                                    onBlur={formikReducePoints.handleBlur}
                                    className={
                                        formikReducePoints.errors.point_amount &&
                                        formikReducePoints.touched.point_amount
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikReducePoints.errors.point_amount &&
                                    formikReducePoints.touched.point_amount && (
                                        <p className="error">{formikReducePoints.errors.point_amount}</p>
                                    )}
                            </Col>

                            <Col lg="12" md="12" sm="12" className='position-relative mt-3'>
                                <h6 className="form-lable required-field">Reason</h6>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    id="remarks"
                                    name="remarks"
                                    value={formikReducePoints.values.remarks}
                                    onChange={formikReducePoints.handleChange}
                                    onBlur={formikReducePoints.handleBlur}
                                    className={
                                        formikReducePoints.errors.remarks &&
                                        formikReducePoints.touched.remarks
                                            ? "input-error"
                                            : ""
                                    }
                                />
                                {formikReducePoints.errors.remarks &&
                                    formikReducePoints.touched.remarks && (
                                        <p className="error">{formikReducePoints.errors.remarks}</p>
                                    )}
                            </Col>
                        </Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="mx-auto d-flex gap-2">
                            <Button
                                variant="contained"
                                className="primary-gray"
                                onClick={toggleModalReducePoints}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                className="primary-filled"
                                disabled={isReducePointsSubmitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default ViewStudent;
